var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudBedSofa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "380px",
    height: "380px",
    viewBox: "0 0 380 380",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 0.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(15.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 131.79,
    y1: 0.2304,
    x2: 161.245,
    y2: 11.4074,
    id: "Stroke-1",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.3691,
    y1: 0.7695,
    x2: 131.7901,
    y2: 0.2305,
    id: "Stroke-2",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.3691,
    y1: 0.7695,
    x2: 130.3691,
    y2: 7.1225,
    id: "Stroke-3",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.9751,
    y1: 287.7827,
    x2: 310.9751,
    y2: 273.4817,
    id: "Stroke-4",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.9751,
    y1: 273.4819,
    x2: 309.5541,
    y2: 272.9419,
    id: "Stroke-5",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.6938,
    y1: 332.725,
    x2: 191.1148,
    y2: 333.264,
    id: "Stroke-6",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.1357,
    y1: 89.6035,
    x2: 35.5567,
    y2: 89.0645,
    id: "Stroke-7",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.5512,
    y1: 15.0844,
    x2: 150.1302,
    y2: 14.5454,
    id: "Stroke-8",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.8296,
    y1: 55.9604,
    x2: 43.8296,
    y2: 61.8934,
    id: "Stroke-9",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.394,
    y1: 165.4951,
    x2: 191.908,
    y2: 165.3101,
    id: "Stroke-10",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.394,
    y1: 165.4951,
    x2: 348.885,
    y2: 106.1141,
    id: "Stroke-11",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.8852,
    y1: 106.1137,
    x2: 348.8852,
    y2: 102.4447,
    id: "Stroke-12",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.394,
    y1: 161.8261,
    x2: 192.394,
    y2: 165.4951,
    id: "Stroke-13",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.4087,
    y1: 56.3491,
    x2: 42.4087,
    y2: 56.3491,
    id: "Stroke-14",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.394,
    y1: 161.8261,
    x2: 191.904,
    y2: 161.6401,
    id: "Stroke-15",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.9424,
    y1: 47.601,
    x2: 23.3634,
    y2: 47.061,
    id: "Stroke-16",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.9424,
    y1: 47.601,
    x2: 21.9424,
    y2: 48.756,
    id: "Stroke-17",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.4824,
    y1: 272.9692,
    x2: 301.7724,
    y2: 270.0432,
    id: "Stroke-18",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3227,236.5502 C49.3007,236.5592 49.2787,236.5692 49.2577,236.5792 C49.2357,236.5912 49.2137,236.6042 49.1937,236.6182 C49.1717,236.6342 49.1507,236.6512 49.1307,236.6682 C49.1097,236.6872 49.0897,236.7062 49.0717,236.7272 C49.0377,236.7642 49.0077,236.8042 48.9817,236.8472 C48.9527,236.8922 48.9287,236.9402 48.9077,236.9892 C48.8887,237.0362 48.8727,237.0852 48.8597,237.1352 C48.8457,237.1862 48.8367,237.2372 48.8297,237.2882 C48.8227,237.3412 48.8197,237.3942 48.8197,237.4462 C48.8187,237.4972 48.8217,237.5482 48.8267,237.5992 C48.8287,237.6122 48.8307,237.6232 48.8317,237.6362 C48.8337,237.6492 48.8357,237.6612 48.8387,237.6742 C48.8427,237.6992 48.8477,237.7242 48.8537,237.7492 C48.8657,237.8002 48.8807,237.8512 48.8997,237.9002 C48.9177,237.9482 48.9397,237.9962 48.9647,238.0422 C48.9897,238.0872 49.0177,238.1302 49.0497,238.1712 C49.0817,238.2132 49.1187,238.2522 49.1587,238.2872 C49.1777,238.3042 49.1977,238.3202 49.2187,238.3342 C49.2397,238.3492 49.2597,238.3622 49.2807,238.3732 C49.3057,238.3872 49.3307,238.3992 49.3567,238.4082 C49.3817,238.4182 49.4067,238.4252 49.4317,238.4322 C49.4567,238.4372 49.4817,238.4422 49.5067,238.4442 C49.5307,238.4462 49.5547,238.4462 49.5787,238.4462",
    id: "Stroke-19",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.98,232.5063 C59.958,232.5143 59.937,232.5253 59.916,232.5353 C59.893,232.5473 59.872,232.5603 59.851,232.5743 C59.829,232.5893 59.808,232.6063 59.789,232.6233 C59.767,232.6423 59.748,232.6623 59.729,232.6833 C59.695,232.7203 59.665,232.7603 59.639,232.8033 C59.611,232.8483 59.586,232.8963 59.566,232.9453 C59.546,232.9923 59.53,233.0413 59.517,233.0913 C59.503,233.1423 59.494,233.1933 59.487,233.2443 C59.48,233.2973 59.477,233.3503 59.477,233.4023 C59.477,233.4533 59.479,233.5043 59.485,233.5553 C59.486,233.5683 59.488,233.5793 59.49,233.5923 C59.491,233.6053 59.493,233.6173 59.496,233.6303 C59.5,233.6543 59.505,233.6803 59.511,233.7053 C59.523,233.7563 59.538,233.8073 59.557,233.8563 C59.575,233.9043 59.597,233.9523 59.623,233.9983 C59.647,234.0433 59.675,234.0863 59.707,234.1263 C59.739,234.1693 59.776,234.2083 59.816,234.2433 C59.835,234.2603 59.855,234.2763 59.876,234.2903 C59.897,234.3043 59.918,234.3183 59.939,234.3293 C59.963,234.3433 59.988,234.3553 60.014,234.3643 C60.039,234.3733 60.064,234.3813 60.089,234.3883 C60.114,234.3933 60.139,234.3983 60.164,234.4003 C60.188,234.4023 60.212,234.4023 60.237,234.4023",
    id: "Stroke-21",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6377,228.4624 C70.6157,228.4704 70.5937,228.4804 70.5737,228.4914 C70.5507,228.5034 70.5297,228.5164 70.5087,228.5304 C70.4877,228.5454 70.4667,228.5624 70.4467,228.5784 C70.4257,228.5974 70.4057,228.6174 70.3877,228.6384 C70.3537,228.6754 70.3237,228.7154 70.2977,228.7574 C70.2687,228.8024 70.2447,228.8494 70.2247,228.8994 C70.2047,228.9454 70.1887,228.9944 70.1757,229.0434 C70.1617,229.0944 70.1517,229.1454 70.1447,229.1954 C70.1377,229.2474 70.1347,229.3004 70.1347,229.3534 C70.1337,229.4034 70.1367,229.4544 70.1417,229.5044 C70.1427,229.5104 70.1427,229.5174 70.1437,229.5234 C70.1447,229.5294 70.1457,229.5354 70.1457,229.5414 L70.1517,229.5794 C70.1557,229.6044 70.1607,229.6294 70.1667,229.6534 C70.1787,229.7054 70.1937,229.7554 70.2117,229.8044 C70.2297,229.8534 70.2507,229.9004 70.2757,229.9464 C70.2997,229.9914 70.3267,230.0344 70.3587,230.0744 C70.3897,230.1174 70.4267,230.1564 70.4657,230.1924 C70.4847,230.2094 70.5047,230.2254 70.5247,230.2404 C70.5447,230.2544 70.5657,230.2684 70.5867,230.2794 C70.6107,230.2934 70.6357,230.3064 70.6607,230.3164 C70.6847,230.3254 70.7097,230.3344 70.7357,230.3414 C70.7597,230.3474 70.7837,230.3524 70.8097,230.3554 C70.8327,230.3574 70.8577,230.3584 70.8817,230.3584",
    id: "Stroke-23",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2832,232.4653 C60.2962,232.4643 60.3082,232.4643 60.3202,232.4643 L60.3422,232.4643 L60.3792,232.4673 C60.3882,232.4683 60.3992,232.4693 60.4082,232.4713 C60.4282,232.4743 60.4472,232.4773 60.4662,232.4823 C60.4762,232.4843 60.4862,232.4863 60.4962,232.4893 C60.5082,232.4923 60.5192,232.4963 60.5312,232.5003 C60.5482,232.5053 60.5652,232.5123 60.5822,232.5203 C60.6102,232.5313 60.6372,232.5443 60.6632,232.5603 C60.6722,232.5653 60.6802,232.5703 60.6892,232.5753 C60.7062,232.5863 60.7222,232.5983 60.7392,232.6113 C60.7472,232.6163 60.7552,232.6223 60.7622,232.6293 C60.7792,232.6413 60.7942,232.6543 60.8082,232.6683 C60.8302,232.6893 60.8512,232.7103 60.8702,232.7343 C60.9082,232.7773 60.9432,232.8253 60.9722,232.8773 C60.9872,232.9023 61.0002,232.9273 61.0132,232.9533 C61.0252,232.9793 61.0362,233.0043 61.0462,233.0303 C61.0552,233.0563 61.0642,233.0813 61.0732,233.1083 C61.0752,233.1163 61.0782,233.1263 61.0802,233.1353 C61.0852,233.1523 61.0892,233.1683 61.0932,233.1853 C61.0982,233.2103 61.1032,233.2363 61.1082,233.2633 C61.1122,233.2903 61.1152,233.3183 61.1172,233.3453 C61.1202,233.3733 61.1212,233.4023 61.1222,233.4293 C61.1222,233.4583 61.1222,233.4873 61.1202,233.5173 C61.1182,233.5463 61.1162,233.5753 61.1122,233.6053 C61.1082,233.6353 61.1032,233.6643 61.0962,233.6943 C61.0902,233.7233 61.0832,233.7523 61.0742,233.7813 C61.0652,233.8103 61.0552,233.8393 61.0442,233.8663 C61.0222,233.9243 60.9942,233.9783 60.9632,234.0273 C60.9472,234.0533 60.9302,234.0773 60.9122,234.1013 C60.8942,234.1243 60.8752,234.1463 60.8552,234.1673 C60.8422,234.1813 60.8282,234.1943 60.8142,234.2063 C60.8072,234.2133 60.8002,234.2203 60.7922,234.2263 C60.7712,234.2443 60.7482,234.2613 60.7252,234.2773 C60.7102,234.2863 60.6962,234.2963 60.6802,234.3043 C60.6722,234.3103 60.6632,234.3153 60.6542,234.3193 C60.6302,234.3313 60.6062,234.3423 60.5812,234.3523",
    id: "Stroke-25",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.4619,
    y1: 224.3833,
    x2: 81.5979,
    y2: 224.3773,
    id: "Stroke-27",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4619,224.3833 C81.4049,224.3863 81.3489,224.3983 81.2949,224.4183",
    id: "Stroke-29",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8042,228.4272 C70.7472,228.4302 70.6912,228.4422 70.6372,228.4622",
    id: "Stroke-31",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.1465,
    y1: 232.4711,
    x2: 60.2835,
    y2: 232.4651,
    id: "Stroke-33",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1465,232.4711 C60.0895,232.4741 60.0335,232.4861 59.9795,232.5061",
    id: "Stroke-35",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.4892,
    y1: 236.5151,
    x2: 49.6262,
    y2: 236.5091,
    id: "Stroke-37",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4892,236.5151 C49.4322,236.5181 49.3762,236.5301 49.3222,236.5501",
    id: "Stroke-39",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.7158,
    y1: 238.4389,
    x2: 49.5788,
    y2: 238.4459,
    id: "Stroke-41",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5791,238.4458 C49.6291,238.4428 49.6771,238.4338 49.7251,238.4188",
    id: "Stroke-43",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.373,
    y1: 234.395,
    x2: 60.237,
    y2: 234.402,
    id: "Stroke-45",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2368,234.4018 C60.2938,234.3988 60.3498,234.3868 60.4038,234.3668",
    id: "Stroke-47",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.0302,
    y1: 230.351,
    x2: 70.8942,
    y2: 230.357,
    id: "Stroke-49",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.688,
    y1: 226.3071,
    x2: 81.552,
    y2: 226.3131,
    id: "Stroke-51",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5517,226.3129 C81.6087,226.3109 81.6647,226.2989 81.7187,226.2789",
    id: "Stroke-53",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.896,226.2641 C81.862,226.2761 81.827,226.2861 81.792,226.2931 C81.758,226.3011 81.723,226.3051 81.688,226.3071",
    id: "Stroke-55",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2383,230.3081 C71.2043,230.3211 71.1703,230.3301 71.1343,230.3381 C71.1003,230.3451 71.0653,230.3491 71.0303,230.3511",
    id: "Stroke-57",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.581,234.352 C60.547,234.365 60.513,234.374 60.477,234.382 C60.443,234.389 60.408,234.393 60.373,234.395",
    id: "Stroke-59",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.4497,
    y1: 7.9023,
    x2: 132.4497,
    y2: 7.9113,
    id: "Stroke-61",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.0283,
    y1: 7.3627,
    x2: 132.4493,
    y2: 7.9027,
    id: "Stroke-63",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.0283,
    y1: 7.3627,
    x2: 139.3823,
    y2: 4.1927,
    id: "Stroke-65",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.5273,
    y1: 90.8276,
    x2: 347.5153,
    y2: 102.5856,
    id: "Stroke-67",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.894,230.3569 C70.951,230.3549 71.007,230.3429 71.061,230.3229",
    id: "Stroke-69",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9145,
    y1: 52.0258,
    x2: 16.9145,
    y2: 52.0268,
    id: "Stroke-71",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.8833,
    y1: 118.039,
    x2: 191.3383,
    y2: 117.866,
    id: "Stroke-73",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6098,216.3305 C102.5878,216.3385 102.5658,216.3485 102.5448,216.3595 C102.5228,216.3715 102.5018,216.3845 102.4808,216.3985 C102.4588,216.4135 102.4378,216.4305 102.4178,216.4475 C102.3968,216.4665 102.3768,216.4855 102.3588,216.5075 C102.3248,216.5445 102.2948,216.5845 102.2688,216.6265 C102.2398,216.6725 102.2158,216.7205 102.1958,216.7685 C102.1758,216.8165 102.1598,216.8655 102.1468,216.9155 C102.1328,216.9655 102.1238,217.0175 102.1168,217.0685 C102.1098,217.1205 102.1068,217.1735 102.1068,217.2265 C102.1058,217.2775 102.1088,217.3285 102.1148,217.3785 L102.1188,217.4165 C102.1208,217.4295 102.1228,217.4405 102.1258,217.4535 C102.1298,217.4785 102.1348,217.5045 102.1408,217.5285 C102.1528,217.5805 102.1678,217.6305 102.1868,217.6805 C102.2048,217.7285 102.2268,217.7765 102.2518,217.8225 C102.2768,217.8665 102.3048,217.9105 102.3368,217.9505 C102.3688,217.9925 102.4058,218.0325 102.4458,218.0675 C102.4648,218.0845 102.4848,218.1005 102.5058,218.1145 C102.5268,218.1285 102.5478,218.1415 102.5688,218.1535 C102.5928,218.1665 102.6178,218.1785 102.6438,218.1875 C102.6688,218.1975 102.6938,218.2055 102.7188,218.2115 C102.7438,218.2175 102.7688,218.2215 102.7938,218.2245 C102.8178,218.2265 102.8418,218.2265 102.8658,218.2255",
    id: "Stroke-75",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.9248,208.2417 C123.9028,208.2507 123.8808,208.2607 123.8598,208.2717 C123.8378,208.2837 123.8168,208.2967 123.7958,208.3107 C123.7738,208.3257 123.7528,208.3427 123.7328,208.3597 C123.7118,208.3787 123.6918,208.3977 123.6738,208.4187 C123.6398,208.4557 123.6098,208.4967 123.5838,208.5387 C123.5548,208.5847 123.5308,208.6317 123.5108,208.6807 C123.4908,208.7287 123.4748,208.7777 123.4618,208.8277 C123.4478,208.8777 123.4388,208.9287 123.4318,208.9807 C123.4248,209.0337 123.4218,209.0857 123.4218,209.1387 C123.4208,209.1897 123.4238,209.2407 123.4298,209.2907 C123.4308,209.3037 123.4318,209.3157 123.4338,209.3277 C123.4358,209.3407 123.4378,209.3527 123.4398,209.3657 C123.4448,209.3907 123.4498,209.4157 123.4558,209.4417 C123.4668,209.4917 123.4828,209.5427 123.5018,209.5917 C123.5198,209.6407 123.5418,209.6887 123.5668,209.7337 C123.5918,209.7787 123.6198,209.8217 123.6508,209.8627 C123.6838,209.9047 123.7208,209.9437 123.7608,209.9787 C123.7798,209.9957 123.7998,210.0127 123.8208,210.0267 C123.8418,210.0407 123.8628,210.0537 123.8838,210.0647 C123.9078,210.0787 123.9328,210.0907 123.9588,210.0997 C123.9838,210.1097 124.0078,210.1177 124.0338,210.1237 C124.0588,210.1297 124.0838,210.1337 124.1088,210.1357 C124.1328,210.1377 124.1568,210.1377 124.1808,210.1377",
    id: "Stroke-77",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5825,204.1977 C134.5605,204.2067 134.5385,204.2167 134.5175,204.2277 C134.4955,204.2397 134.4735,204.2527 134.4535,204.2667 C134.4315,204.2817 134.4105,204.2987 134.3905,204.3157 C134.3695,204.3337 134.3495,204.3537 134.3315,204.3747 C134.2965,204.4117 134.2675,204.4527 134.2405,204.4947 C134.2125,204.5407 134.1885,204.5877 134.1675,204.6367 C134.1475,204.6847 134.1315,204.7337 134.1185,204.7827 C134.1055,204.8337 134.0955,204.8847 134.0895,204.9367 C134.0825,204.9897 134.0795,205.0417 134.0785,205.0947 C134.0785,205.1447 134.0815,205.1967 134.0865,205.2467 C134.0885,205.2597 134.0895,205.2717 134.0915,205.2837 C134.0935,205.2967 134.0955,205.3087 134.0975,205.3217 C134.1025,205.3467 134.1065,205.3717 134.1125,205.3977 C134.1245,205.4477 134.1405,205.4987 134.1585,205.5477 C134.1775,205.5967 134.1995,205.6447 134.2245,205.6897 C134.2495,205.7347 134.2775,205.7777 134.3085,205.8187 C134.3415,205.8607 134.3775,205.8997 134.4185,205.9357 C134.4375,205.9517 134.4575,205.9677 134.4785,205.9827 C134.4985,205.9967 134.5195,206.0097 134.5405,206.0217 C134.5655,206.0347 134.5905,206.0467 134.6165,206.0557 C134.6405,206.0657 134.6655,206.0737 134.6915,206.0797 C134.7165,206.0857 134.7415,206.0897 134.7665,206.0917 C134.7905,206.0937 134.8145,206.0937 134.8385,206.0937",
    id: "Stroke-79",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5703,212.2446 C113.5833,212.2446 113.5953,212.2436 113.6083,212.2446 L113.6293,212.2446 C113.6423,212.2456 113.6543,212.2456 113.6663,212.2476 C113.6763,212.2486 113.6863,212.2496 113.6953,212.2506 C113.7153,212.2536 113.7343,212.2576 113.7533,212.2616 C113.7633,212.2646 113.7733,212.2656 113.7833,212.2686 C113.7953,212.2726 113.8063,212.2756 113.8183,212.2796 C113.8353,212.2856 113.8523,212.2926 113.8693,212.2996 C113.8973,212.3106 113.9243,212.3246 113.9503,212.3406 C113.9593,212.3456 113.9673,212.3496 113.9763,212.3556 C113.9933,212.3666 114.0103,212.3786 114.0263,212.3906 C114.0343,212.3956 114.0423,212.4026 114.0503,212.4086 C114.0663,212.4216 114.0813,212.4346 114.0953,212.4486 C114.1173,212.4696 114.1383,212.4906 114.1573,212.5136 C114.1953,212.5566 114.2303,212.6056 114.2593,212.6566 C114.2743,212.6816 114.2873,212.7066 114.3003,212.7326 C114.3123,212.7586 114.3233,212.7836 114.3333,212.8096 C114.3433,212.8356 114.3513,212.8616 114.3603,212.8886 C114.3623,212.8966 114.3653,212.9056 114.3673,212.9146 C114.3723,212.9316 114.3763,212.9476 114.3803,212.9656 C114.3853,212.9906 114.3913,213.0166 114.3953,213.0436 C114.3993,213.0696 114.4023,213.0976 114.4043,213.1246 C114.4073,213.1526 114.4083,213.1816 114.4093,213.2096 C114.4093,213.2386 114.4093,213.2676 114.4073,213.2966 C114.4053,213.3266 114.4033,213.3556 114.3993,213.3856 C114.3953,213.4146 114.3903,213.4436 114.3833,213.4736 C114.3773,213.5036 114.3703,213.5326 114.3613,213.5606 C114.3523,213.5906 114.3423,213.6186 114.3313,213.6466 C114.3093,213.7036 114.2813,213.7576 114.2503,213.8076 C114.2343,213.8336 114.2173,213.8566 114.1993,213.8806 C114.1813,213.9036 114.1623,213.9266 114.1423,213.9466 C114.1293,213.9616 114.1153,213.9736 114.1013,213.9866 C114.0943,213.9936 114.0873,213.9996 114.0793,214.0066 C114.0583,214.0236 114.0353,214.0416 114.0123,214.0566 C113.9973,214.0666 113.9833,214.0756 113.9673,214.0846 L113.9413,214.0986 C113.9173,214.1106 113.8933,214.1226 113.8683,214.1316",
    id: "Stroke-81",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8852,204.1567 C134.8972,204.1567 134.9102,204.1557 134.9232,204.1557 C134.9292,204.1567 134.9372,204.1567 134.9442,204.1567 C134.9562,204.1567 134.9692,204.1577 134.9812,204.1587 C134.9912,204.1597 135.0012,204.1607 135.0102,204.1627 C135.0302,204.1657 135.0492,204.1687 135.0682,204.1737 C135.0782,204.1757 135.0882,204.1777 135.0982,204.1807 C135.1102,204.1847 135.1212,204.1877 135.1332,204.1917 C135.1502,204.1977 135.1672,204.2037 135.1842,204.2117 C135.2122,204.2227 135.2392,204.2367 135.2652,204.2517 C135.2742,204.2577 135.2822,204.2617 135.2912,204.2677 C135.3082,204.2787 135.3252,204.2897 135.3412,204.3027 C135.3492,204.3077 135.3572,204.3147 135.3652,204.3207 C135.3812,204.3337 135.3962,204.3467 135.4102,204.3607 C135.4322,204.3807 135.4532,204.4027 135.4722,204.4257 C135.5102,204.4687 135.5452,204.5177 135.5742,204.5697 C135.5892,204.5937 135.6022,204.6187 135.6142,204.6447 C135.6272,204.6707 135.6382,204.6957 135.6482,204.7227 C135.6572,204.7477 135.6662,204.7737 135.6752,204.7997 C135.6772,204.8087 135.6792,204.8177 135.6822,204.8267 C135.6872,204.8437 135.6912,204.8597 135.6952,204.8767 C135.7002,204.9027 135.7062,204.9287 135.7102,204.9547 C135.7142,204.9817 135.7182,205.0097 135.7192,205.0367 C135.7222,205.0647 135.7242,205.0937 135.7242,205.1217 C135.7242,205.1507 135.7242,205.1797 135.7222,205.2087 C135.7202,205.2387 135.7182,205.2677 135.7142,205.2967 C135.7102,205.3267 135.7052,205.3567 135.6982,205.3857 C135.6922,205.4147 135.6842,205.4447 135.6762,205.4727 C135.6672,205.5027 135.6572,205.5307 135.6462,205.5587 C135.6242,205.6157 135.5972,205.6697 135.5652,205.7197 C135.5492,205.7447 135.5322,205.7697 135.5142,205.7927 C135.4962,205.8157 135.4772,205.8377 135.4572,205.8587 C135.4442,205.8727 135.4302,205.8857 135.4162,205.8987 L135.3942,205.9177 C135.3732,205.9367 135.3502,205.9527 135.3272,205.9687 C135.3122,205.9787 135.2982,205.9877 135.2822,205.9967 C135.2742,206.0017 135.2652,206.0067 135.2562,206.0107 C135.2322,206.0227 135.2082,206.0337 135.1832,206.0437",
    id: "Stroke-83",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.749,
    y1: 204.163,
    x2: 134.885,
    y2: 204.157,
    id: "Stroke-85",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.749,204.163 C134.692,204.166 134.636,204.178 134.582,204.198",
    id: "Stroke-87",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.0913,
    y1: 208.207,
    x2: 124.2283,
    y2: 208.201,
    id: "Stroke-89",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.0913,208.207 C124.0343,208.21 123.9783,208.222 123.9243,208.242",
    id: "Stroke-91",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.4341,
    y1: 212.2514,
    x2: 113.5701,
    y2: 212.2444,
    id: "Stroke-93",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.4341,212.2514 C113.3771,212.2534 113.3211,212.2664 113.2671,212.2864",
    id: "Stroke-95",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.7768,
    y1: 216.2954,
    x2: 102.9128,
    y2: 216.2884,
    id: "Stroke-97",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.7768,216.2954 C102.7188,216.2974 102.6638,216.3104 102.6098,216.3304",
    id: "Stroke-99",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6538,183.3959 C133.6838,183.3839 133.7148,183.3739 133.7458,183.3629 C133.7788,183.3519 133.8138,183.3409 133.8468,183.3309 C133.8968,183.3169 133.9468,183.3039 133.9978,183.2919 C134.0238,183.2859 134.0498,183.2809 134.0748,183.2759 C134.1478,183.2619 134.2208,183.2499 134.2948,183.2429 C134.3848,183.2329 134.4768,183.2289 134.5678,183.2289 C134.6588,183.2289 134.7508,183.2329 134.8408,183.2429 C134.9148,183.2499 134.9878,183.2619 135.0608,183.2759 C135.0858,183.2809 135.1118,183.2859 135.1378,183.2919 C135.1888,183.3039 135.2388,183.3169 135.2888,183.3309 C135.3218,183.3409 135.3558,183.3519 135.3898,183.3629 C135.4208,183.3739 135.4508,183.3839 135.4818,183.3959",
    id: "Stroke-101",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.0029,
    y1: 218.2192,
    x2: 102.8659,
    y2: 218.2252,
    id: "Stroke-103",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8662,218.225 C102.9232,218.222 102.9792,218.21 103.0332,218.191",
    id: "Stroke-105",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.6601,
    y1: 214.1752,
    x2: 113.5241,
    y2: 214.1812,
    id: "Stroke-107",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5239,214.1811 C113.5809,214.1781 113.6369,214.1661 113.6909,214.1461",
    id: "Stroke-109",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.9751,
    y1: 206.0869,
    x2: 134.8391,
    y2: 206.0929,
    id: "Stroke-111",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8388,206.0932 C134.8958,206.0902 134.9518,206.0782 135.0058,206.0582",
    id: "Stroke-113",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1831,206.0434 C135.1491,206.0564 135.1141,206.0664 135.0791,206.0734 C135.0451,206.0814 135.0101,206.0854 134.9751,206.0864",
    id: "Stroke-115",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5254,210.0874 C124.4914,210.1004 124.4574,210.1104 124.4214,210.1174 C124.3874,210.1244 124.3524,210.1294 124.3174,210.1304",
    id: "Stroke-117",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8681,214.1313 C113.8341,214.1443 113.8001,214.1543 113.7641,214.1613 C113.7301,214.1683 113.6951,214.1733 113.6601,214.1753",
    id: "Stroke-119",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.2104,218.1752 C103.1764,218.1882 103.1424,218.1982 103.1064,218.2052 C103.0724,218.2132 103.0374,218.2172 103.0024,218.2192",
    id: "Stroke-121",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2378,208.2207 C124.1898,208.2097 124.1408,208.2047 124.0918,208.2067",
    id: "Stroke-123",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.9555,
    y1: 89.1298,
    x2: 0.4995,
    y2: 88.9568,
    id: "Stroke-125",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 311.8188,
    x2: 0.5,
    y2: 88.9568,
    id: "Stroke-127",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.9555,
    y1: 311.9917,
    x2: 0.4995,
    y2: 311.8187,
    id: "Stroke-129",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.4155,
    y1: 102.3652,
    x2: 26.4155,
    y2: 252.8962,
    id: "Stroke-131",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.3559,
    y1: 103.4809,
    x2: 29.3559,
    y2: 223.6649,
    id: "Stroke-133",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.0776,
    y1: 104.1342,
    x2: 31.0776,
    y2: 222.3192,
    id: "Stroke-135",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.018,
    y1: 105.2499,
    x2: 34.018,
    y2: 221.2039,
    id: "Stroke-137",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.7392,
    y1: 105.9033,
    x2: 35.7392,
    y2: 220.5503,
    id: "Stroke-139",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.2495,
    y1: 106.8554,
    x2: 38.2495,
    y2: 219.5984,
    id: "Stroke-141",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.5874,
    y1: 105.0864,
    x2: 33.5874,
    y2: 221.3664,
    id: "Stroke-143",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5122,203.7363 C82.5272,203.6963 82.5432,203.6563 82.5602,203.6173 C82.5982,203.5303 82.6402,203.4453 82.6872,203.3633 C82.7362,203.2783 82.7892,203.1963 82.8462,203.1183 C82.8662,203.0913 82.8862,203.0653 82.9072,203.0393 C82.9212,203.0213 82.9352,203.0043 82.9502,202.9863 C82.9782,202.9523 83.0082,202.9193 83.0382,202.8873 C83.0972,202.8233 83.1592,202.7623 83.2252,202.7053 C83.2382,202.6943 83.2502,202.6833 83.2622,202.6733 C83.3732,202.5793 83.4922,202.4953 83.6182,202.4213 C83.6782,202.3863 83.7392,202.3533 83.8012,202.3233 C83.8372,202.3063 83.8742,202.2893 83.9112,202.2733 C83.9442,202.2593 83.9772,202.2463 84.0102,202.2333",
    id: "Stroke-145",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2954,224.4184 C81.2734,224.4264 81.2514,224.4364 81.2304,224.4474 C81.2084,224.4594 81.1864,224.4724 81.1664,224.4864 C81.1444,224.5014 81.1234,224.5184 81.1034,224.5354 C81.0824,224.5544 81.0624,224.5734 81.0434,224.5954 C81.0094,224.6324 80.9804,224.6724 80.9534,224.7154 C80.9254,224.7604 80.9014,224.8084 80.8804,224.8564 C80.8604,224.9044 80.8444,224.9534 80.8314,225.0034 C80.8184,225.0544 80.8084,225.1054 80.8014,225.1564 C80.7954,225.2094 80.7924,225.2624 80.7914,225.3144 C80.7914,225.3654 80.7944,225.4164 80.7994,225.4664 C80.8004,225.4794 80.8024,225.4914 80.8044,225.5044 C80.8064,225.5174 80.8084,225.5284 80.8104,225.5414 C80.8154,225.5664 80.8194,225.5924 80.8254,225.6174 C80.8374,225.6684 80.8534,225.7184 80.8714,225.7684 C80.8904,225.8164 80.9124,225.8644 80.9374,225.9104 C80.9624,225.9544 80.9904,225.9984 81.0214,226.0384 C81.0544,226.0804 81.0904,226.1204 81.1314,226.1554 C81.1504,226.1724 81.1704,226.1884 81.1914,226.2024 C81.2114,226.2164 81.2324,226.2304 81.2534,226.2414 C81.2774,226.2544 81.3034,226.2664 81.3294,226.2754 C81.3534,226.2854 81.3784,226.2934 81.4044,226.2994 C81.4294,226.3054 81.4544,226.3094 81.4794,226.3124 C81.5034,226.3144 81.5274,226.3144 81.5514,226.3134",
    id: "Stroke-147",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.4302,
    y1: 309.27,
    x2: 14.9402,
    y2: 308.317,
    id: "Stroke-149",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.709,
    y1: 308.6167,
    x2: 12.43,
    y2: 309.2697,
    id: "Stroke-151",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.7685,
    y1: 311.0385,
    x2: 10.2785,
    y2: 310.0865,
    id: "Stroke-153",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.0473,
    y1: 310.3852,
    x2: 7.7683,
    y2: 311.0382,
    id: "Stroke-155",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.1069,
    y1: 312.8081,
    x2: 5.6169,
    y2: 311.8551,
    id: "Stroke-157",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.9555,
    y1: 311.9917,
    x2: 3.1065,
    y2: 312.8077,
    id: "Stroke-159",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.9555,
    y1: 89.1298,
    x2: 0.9555,
    y2: 311.9918,
    id: "Stroke-161",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.2788,
    y1: 308.7797,
    x2: 10.7088,
    y2: 308.6167,
    id: "Stroke-163",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.6172,
    y1: 310.5493,
    x2: 6.0472,
    y2: 310.3853,
    id: "Stroke-165",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.3613,
    y1: 316.2602,
    x2: 195.3613,
    y2: 316.2742,
    id: "Stroke-167",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.018,
    y1: 276.1684,
    x2: 301.018,
    y2: 276.1814,
    id: "Stroke-169",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.1098,258.767 C300.2658,258.826 300.4148,258.9 300.5558,258.988 C300.6838,259.067 300.8048,259.158 300.9168,259.258 C300.9898,259.324 301.0588,259.393 301.1238,259.466 C301.2328,259.589 301.3288,259.722 301.4128,259.863 C301.5308,260.062 301.6218,260.277 301.6828,260.5 C301.7118,260.61 301.7348,260.721 301.7498,260.833 C301.7648,260.947 301.7728,261.061 301.7728,261.175",
    id: "Stroke-171",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.2773,
    y1: 149.5639,
    x2: 316.5273,
    y2: 102.4159,
    id: "Stroke-173",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.2773,
    y1: 149.5639,
    x2: 192.2773,
    y2: 118.5679,
    id: "Stroke-175",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.832,321.0532 C291.832,321.0662 291.831,321.0772 291.829,321.0902",
    id: "Stroke-177",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.7729,
    y1: 320.1225,
    x2: 289.7129,
    y2: 320.4755,
    id: "Stroke-179",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.8286,321.0903 C291.8266,321.1033 291.8236,321.1163 291.8206,321.1293 C291.8156,321.1463 291.8096,321.1623 291.8036,321.1783 C291.7976,321.1923 291.7916,321.2033 291.7856,321.2163 C291.7806,321.2263 291.7746,321.2363 291.7686,321.2463 C291.7616,321.2573 291.7546,321.2673 291.7476,321.2773 L291.7436,321.2823 C291.7366,321.2923 291.7296,321.3003 291.7226,321.3093 C291.7126,321.3203 291.7026,321.3313 291.6916,321.3423 C291.6826,321.3513 291.6726,321.3603 291.6626,321.3683 C291.6606,321.3713 291.6566,321.3743 291.6536,321.3763 C291.6346,321.3933 291.6146,321.4083 291.5936,321.4223 C291.5766,321.4343 291.5596,321.4443 291.5426,321.4543 C291.5246,321.4653 291.5066,321.4743 291.4886,321.4843 C291.4706,321.4933 291.4516,321.5023 291.4316,321.5113 C291.4126,321.5193 291.3926,321.5273 291.3716,321.5343 C291.3516,321.5433 291.3306,321.5503 291.3096,321.5583 C291.2876,321.5653 291.2666,321.5703 291.2446,321.5773 C291.2226,321.5843 291.2006,321.5903 291.1776,321.5963 C291.1546,321.6013 291.1316,321.6073 291.1086,321.6113 C291.0856,321.6163 291.0626,321.6213 291.0386,321.6253 C290.9926,321.6343 290.9446,321.6413 290.8956,321.6473 C290.8716,321.6503 290.8476,321.6523 290.8236,321.6553 C290.7756,321.6593 290.7286,321.6623 290.6806,321.6653 C290.6566,321.6663 290.6336,321.6673 290.6096,321.6673 C290.5646,321.6683 290.5186,321.6683 290.4736,321.6673 C290.4286,321.6663 290.3826,321.6633 290.3376,321.6603 C290.3146,321.6593 290.2916,321.6573 290.2686,321.6543 C290.2216,321.6513 290.1756,321.6453 290.1296,321.6383 C290.1056,321.6343 290.0826,321.6303 290.0596,321.6263 C290.0366,321.6223 290.0136,321.6173 289.9906,321.6123 C289.9836,321.6113 289.9756,321.6103 289.9696,321.6093 C289.9306,321.6003 289.8926,321.5903 289.8566,321.5803 C289.8216,321.5693 289.7886,321.5603 289.7566,321.5483 C289.7256,321.5373 289.6976,321.5263 289.6686,321.5143 C289.6486,321.5053 289.6296,321.4963 289.6116,321.4873 C289.5896,321.4773 289.5686,321.4653 289.5486,321.4533 C289.5276,321.4413 289.5066,321.4273 289.4866,321.4133 C289.4706,321.4023 289.4546,321.3903 289.4396,321.3763 C289.4296,321.3683 289.4196,321.3603 289.4106,321.3513 C289.4076,321.3483 289.4046,321.3453 289.4016,321.3423 C289.3976,321.3383 289.3936,321.3333 289.3896,321.3293 C289.3826,321.3223 289.3756,321.3153 289.3696,321.3073 C289.3606,321.2973 289.3526,321.2873 289.3456,321.2773 C289.3376,321.2673 289.3306,321.2573 289.3246,321.2463 C289.3186,321.2363 289.3126,321.2263 289.3076,321.2163 C289.3006,321.2023 289.2936,321.1893 289.2876,321.1743 C289.2846,321.1643 289.2806,321.1543 289.2776,321.1443 C289.2726,321.1303 289.2686,321.1153 289.2656,321.1023 C289.2646,321.0923 289.2626,321.0833 289.2616,321.0743 C289.2606,321.0663 289.2596,321.0573 289.2596,321.0483 C289.2586,321.0393 289.2586,321.0303 289.2586,321.0223",
    id: "Stroke-181",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.2583,321.0219 C289.2583,320.9999 289.2603,320.9769 289.2643,320.9549",
    id: "Stroke-183",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.8344,321.0219 C291.8344,321.0329 291.8344,321.0429 291.8324,321.0529",
    id: "Stroke-185",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.7729,
    y1: 320.4897,
    x2: 289.7739,
    y2: 320.4897,
    id: "Stroke-187",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.9555,
    y1: 89.1298,
    x2: 3.1065,
    y2: 89.9458,
    id: "Stroke-189",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.7724,
    y1: 272.2006,
    x2: 306.6404,
    y2: 274.0476,
    id: "Stroke-191",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.8833,
    y1: 118.039,
    x2: 190.8833,
    y2: 118.039,
    id: "Stroke-193",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.5273,
    y1: 71.4208,
    x2: 315.1513,
    y2: 70.8988,
    id: "Stroke-195",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.6025,
    y1: 99.7797,
    x2: 19.6025,
    y2: 250.3917,
    id: "Stroke-197",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.3711,
    y1: 200.9848,
    x2: 15.3711,
    y2: 251.9978,
    id: "Stroke-199",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.3711,
    y1: 98.1743,
    x2: 15.3711,
    y2: 191.0563,
    id: "Stroke-201",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.0327,
    y1: 99.9433,
    x2: 20.0327,
    y2: 250.4743,
    id: "Stroke-203",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.7539,
    y1: 100.5961,
    x2: 21.7539,
    y2: 251.1261,
    id: "Stroke-205",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.9438,
    y1: 194.6694,
    x2: 103.9438,
    y2: 131.7834,
    id: "Stroke-207",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.2822,
    y1: 196.4384,
    x2: 99.2822,
    y2: 130.0154,
    id: "Stroke-209",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.6201,
    y1: 198.2075,
    x2: 94.6201,
    y2: 128.2465,
    id: "Stroke-211",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.665,
    y1: 194.0161,
    x2: 105.665,
    y2: 132.4371,
    id: "Stroke-213",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.0034,
    y1: 195.7851,
    x2: 101.0034,
    y2: 130.6681,
    id: "Stroke-215",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.3418,
    y1: 197.5542,
    x2: 96.3418,
    y2: 128.8992,
    id: "Stroke-217",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.1753,
    y1: 193.0639,
    x2: 108.1753,
    y2: 133.3889,
    id: "Stroke-219",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.5136,
    y1: 194.8325,
    x2: 103.5136,
    y2: 131.6205,
    id: "Stroke-221",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.9589,
    y1: 194.9047,
    x2: 142.9589,
    y2: 146.5887,
    id: "Stroke-223",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.2378,
    y1: 187.3339,
    x2: 141.2378,
    y2: 145.9349,
    id: "Stroke-225",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.2973,
    y1: 184.4643,
    x2: 138.2973,
    y2: 144.8193,
    id: "Stroke-227",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.9589,
    y1: 99.5082,
    x2: 142.9589,
    y2: 52.9062,
    id: "Stroke-229",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.2378,
    y1: 98.8549,
    x2: 141.2378,
    y2: 53.5599,
    id: "Stroke-231",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.2973,
    y1: 97.7392,
    x2: 138.2973,
    y2: 54.6752,
    id: "Stroke-233",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.4692,
    y1: 100.4609,
    x2: 145.4692,
    y2: 51.9539,
    id: "Stroke-235",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.8071,
    y1: 98.6918,
    x2: 140.8071,
    y2: 53.7228,
    id: "Stroke-237",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.4541,
    y1: 105.7675,
    x2: 159.4541,
    y2: 46.7125,
    id: "Stroke-239",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.9443,
    y1: 104.8154,
    x2: 156.9443,
    y2: 45.7594,
    id: "Stroke-241",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.2226,
    y1: 104.162,
    x2: 155.2226,
    y2: 45.106,
    id: "Stroke-243",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.2822,
    y1: 103.0463,
    x2: 152.2822,
    y2: 43.9903,
    id: "Stroke-245",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.561,
    y1: 102.393,
    x2: 150.561,
    y2: 50.021,
    id: "Stroke-247",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.6206,
    y1: 101.2773,
    x2: 147.6206,
    y2: 51.1373,
    id: "Stroke-249",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.8994,
    y1: 100.624,
    x2: 145.8994,
    y2: 51.791,
    id: "Stroke-251",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.9438,
    y1: 84.7036,
    x2: 103.9438,
    y2: 67.7106,
    id: "Stroke-253",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.2822,
    y1: 82.935,
    x2: 99.2822,
    y2: 69.48,
    id: "Stroke-255",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.6201,
    y1: 81.166,
    x2: 94.6201,
    y2: 71.249,
    id: "Stroke-257",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.665,
    y1: 85.3569,
    x2: 105.665,
    y2: 67.0579,
    id: "Stroke-259",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.0034,
    y1: 83.5878,
    x2: 101.0034,
    y2: 68.8268,
    id: "Stroke-261",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.3418,
    y1: 81.8193,
    x2: 96.3418,
    y2: 70.5953,
    id: "Stroke-263",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.7924,
    y1: 103.9985,
    x2: 154.7924,
    y2: 44.9435,
    id: "Stroke-265",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.1308,
    y1: 102.2299,
    x2: 150.1308,
    y2: 50.1849,
    id: "Stroke-267",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.1753,
    y1: 86.3095,
    x2: 108.1753,
    y2: 66.1055,
    id: "Stroke-269",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.852,
    y1: 82.7714,
    x2: 98.852,
    y2: 69.6434,
    id: "Stroke-271",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.852,
    y1: 196.6015,
    x2: 98.852,
    y2: 129.8515,
    id: "Stroke-273",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.6797,
    y1: 107.019,
    x2: 38.6797,
    y2: 219.434,
    id: "Stroke-275",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.4009,
    y1: 107.6718,
    x2: 40.4009,
    y2: 218.7818,
    id: "Stroke-277",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.3413,
    y1: 108.7875,
    x2: 43.3413,
    y2: 217.6655,
    id: "Stroke-279",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.0625,
    y1: 109.4409,
    x2: 45.0625,
    y2: 217.0119,
    id: "Stroke-281",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.5727,
    y1: 110.3935,
    x2: 47.5727,
    y2: 216.0605,
    id: "Stroke-283",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.0029,
    y1: 110.5566,
    x2: 48.0029,
    y2: 215.8966,
    id: "Stroke-285",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.7246,
    y1: 111.2099,
    x2: 49.7246,
    y2: 215.2439,
    id: "Stroke-287",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.2344,
    y1: 112.1625,
    x2: 52.2344,
    y2: 214.2905,
    id: "Stroke-289",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.8071,
    y1: 186.0122,
    x2: 140.8071,
    y2: 145.7722,
    id: "Stroke-291",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.8852,
    y1: 102.4448,
    x2: 316.5372,
    y2: 90.2258,
    id: "Stroke-293",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.27,
    y1: 102.6806,
    x2: 316.527,
    y2: 91.0146,
    id: "Stroke-295",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.2451,
    y1: 11.4072,
    x2: 161.2451,
    y2: 12.4852,
    id: "Stroke-297",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.1147,
    y1: 318.9633,
    x2: 191.1147,
    y2: 333.2643,
    id: "Stroke-299",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.6938,
    y1: 318.4243,
    x2: 191.1148,
    y2: 318.9633,
    id: "Stroke-301",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.4087,
    y1: 61.3539,
    x2: 42.4087,
    y2: 55.4209,
    id: "Stroke-303",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.4087,
    y1: 55.4213,
    x2: 43.8297,
    y2: 55.9603,
    id: "Stroke-305",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9233,238.3959 C49.8893,238.4089 49.8553,238.4179 49.8193,238.4259 C49.7853,238.4329 49.7503,238.4369 49.7153,238.4389",
    id: "Stroke-307",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.8115,
    y1: 4.7289,
    x2: 132.4495,
    y2: 7.9019,
    id: "Stroke-309",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9131,216.2885 C102.9251,216.2885 102.9381,216.2875 102.9501,216.2885 L102.9721,216.2885 L103.0091,216.2915 L103.0381,216.2945 C103.0581,216.2975 103.0771,216.3015 103.0961,216.3055 C103.1061,216.3085 103.1161,216.3095 103.1261,216.3125 C103.1381,216.3165 103.1491,216.3195 103.1611,216.3235 C103.1781,216.3295 103.1951,216.3365 103.2111,216.3435 C103.2391,216.3545 103.2671,216.3685 103.2931,216.3845 C103.3021,216.3895 103.3101,216.3935 103.3191,216.3995 C103.3361,216.4105 103.3531,216.4225 103.3691,216.4345 C103.3771,216.4405 103.3851,216.4465 103.3931,216.4525 C103.4081,216.4655 103.4231,216.4785 103.4381,216.4925 C103.4601,216.5135 103.4801,216.5345 103.5001,216.5575 C103.5381,216.6015 103.5731,216.6495 103.6021,216.7005 C103.6171,216.7255 103.6301,216.7515 103.6421,216.7765 C103.6551,216.8025 103.6651,216.8275 103.6761,216.8545 C103.6851,216.8795 103.6941,216.9055 103.7021,216.9325 C103.7051,216.9405 103.7071,216.9495 103.7101,216.9595 C103.7151,216.9755 103.7191,216.9925 103.7231,217.0095 C103.7281,217.0345 103.7331,217.0605 103.7381,217.0875 C103.7421,217.1145 103.7451,217.1415 103.7471,217.1685 C103.7501,217.1965 103.7511,217.2255 103.7521,217.2535 C103.7521,217.2825 103.7511,217.3115 103.7501,217.3405 C103.7481,217.3705 103.7461,217.3995 103.7421,217.4295 C103.7381,217.4585 103.7331,217.4885 103.7261,217.5175 C103.7201,217.5475 103.7121,217.5765 103.7041,217.6045 C103.6951,217.6345 103.6851,217.6625 103.6741,217.6905 C103.6521,217.7475 103.6241,217.8015 103.5931,217.8515 C103.5771,217.8775 103.5601,217.9015 103.5421,217.9255 C103.5241,217.9475 103.5051,217.9705 103.4851,217.9905 C103.4721,218.0055 103.4581,218.0175 103.4441,218.0305 C103.4371,218.0375 103.4301,218.0435 103.4221,218.0505 C103.4001,218.0685 103.3781,218.0855 103.3551,218.1005 C103.3401,218.1105 103.3251,218.1195 103.3101,218.1285 L103.2841,218.1425 C103.2601,218.1545 103.2361,218.1665 103.2101,218.1755",
    id: "Stroke-311",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.1069,
    y1: 89.9462,
    x2: 3.1069,
    y2: 256.6522,
    id: "Stroke-313",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.6172,
    y1: 94.4731,
    x2: 5.6172,
    y2: 255.6991,
    id: "Stroke-315",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.0473,
    y1: 94.6362,
    x2: 6.0473,
    y2: 255.5352,
    id: "Stroke-317",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.9404,
    y1: 201.1513,
    x2: 14.9404,
    y2: 252.1613,
    id: "Stroke-319",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.9404,
    y1: 98.0107,
    x2: 14.9404,
    y2: 191.2227,
    id: "Stroke-321",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.2641,320.9545 C289.2661,320.9405 289.2691,320.9275 289.2731,320.9145 C289.2771,320.8975 289.2831,320.8815 289.2891,320.8655 C289.2951,320.8525 289.3011,320.8405 289.3071,320.8275 C289.3121,320.8175 289.3181,320.8085 289.3251,320.7985 C289.3311,320.7865 289.3381,320.7765 289.3451,320.7675 L289.3491,320.7615 C289.3561,320.7525 289.3631,320.7435 289.3701,320.7345 C289.3801,320.7245 289.3901,320.7125 289.4011,320.7015 C289.4101,320.6925 289.4201,320.6835 289.4301,320.6755 C289.4331,320.6725 289.4361,320.6705 289.4391,320.6675 C289.4581,320.6505 289.4791,320.6365 289.4991,320.6215 C289.5161,320.6105 289.5331,320.6005 289.5501,320.5895 C289.5681,320.5795 289.5861,320.5695 289.6041,320.5595 C289.6231,320.5515 289.6411,320.5425 289.6611,320.5335 C289.6781,320.5255 289.6951,320.5185 289.7131,320.5125",
    id: "Stroke-323",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1943,306.52 C84.1113,306.552 84.0263,306.583 83.9393,306.614 C83.8503,306.645 83.7603,306.675 83.6683,306.705 C83.6373,306.714 83.6063,306.725 83.5743,306.735 C83.5583,306.74 83.5423,306.745 83.5273,306.749 L83.4283,306.779 C83.4123,306.784 83.3953,306.789 83.3783,306.793 C83.3443,306.803 83.3103,306.813 83.2763,306.823 C83.2583,306.828 83.2413,306.832 83.2233,306.836 C83.2063,306.841 83.1883,306.846 83.1673,306.852 C83.1323,306.861 83.0973,306.871 83.0623,306.879 C83.0063,306.893 82.9493,306.907 82.8923,306.92 C82.8323,306.934 82.7733,306.947 82.7123,306.959 C82.6923,306.964 82.6713,306.968 82.6503,306.972 C82.6393,306.975 82.6293,306.977 82.6183,306.979 C82.5973,306.983 82.5753,306.987 82.5543,306.992 C82.5433,306.994 82.5323,306.996 82.5213,306.998 L82.4543,307.009 L82.4203,307.015 C82.3973,307.019 82.3733,307.023 82.3503,307.027 C82.3383,307.029 82.3263,307.031 82.3153,307.033 C82.2913,307.037 82.2663,307.041 82.2423,307.043 C82.2293,307.045 82.2173,307.047 82.2043,307.049 C82.1793,307.053 82.1533,307.056 82.1283,307.06 C82.1153,307.061 82.1023,307.063 82.0893,307.065 C82.0623,307.068 82.0363,307.071 82.0093,307.074 C81.9953,307.076 81.9823,307.078 81.9683,307.079 C81.9403,307.082 81.9123,307.084 81.8843,307.087 C81.8703,307.088 81.8563,307.09 81.8413,307.091 C81.7973,307.095 81.7533,307.098 81.7083,307.102 C81.6623,307.105 81.6153,307.108 81.5693,307.11 C81.5453,307.111 81.5203,307.112 81.4963,307.113 C81.4723,307.114 81.4473,307.114 81.4233,307.115 C81.3733,307.116 81.3233,307.117 81.2733,307.117 C81.2243,307.116 81.1743,307.116 81.1263,307.114 C81.0773,307.113 81.0293,307.112 80.9813,307.109 C80.9353,307.107 80.8893,307.104 80.8423,307.101 C80.7983,307.098 80.7543,307.094 80.7103,307.09 C80.6963,307.089 80.6813,307.087 80.6673,307.086 L80.6643,307.086",
    id: "Stroke-325",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.3193,203.351 C154.2923,203.361 154.2653,203.371 154.2373,203.379 C154.2073,203.389 154.1763,203.396 154.1453,203.404 C154.1163,203.411 154.0873,203.417 154.0583,203.423 C154.0273,203.429 153.9973,203.434 153.9653,203.438 C153.8463,203.456 153.7223,203.464 153.6023,203.464 C153.4813,203.464 153.3583,203.456 153.2383,203.438 C153.2073,203.434 153.1763,203.429 153.1453,203.423 C153.1163,203.417 153.0883,203.411 153.0593,203.404 C153.0283,203.397 152.9973,203.389 152.9663,203.379 C152.9393,203.371 152.9113,203.361 152.8843,203.351",
    id: "Stroke-327",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.4541,
    y1: 197.3242,
    x2: 220.5161,
    y2: 220.4942,
    id: "Stroke-329",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.5161,
    y1: 224.2133,
    x2: 220.5161,
    y2: 220.4943,
    id: "Stroke-331",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.1386,201.3632 C159.1386,201.3812 159.1356,201.3982 159.1296,201.4152 C159.1266,201.4232 159.1226,201.4312 159.1186,201.4382 C159.1146,201.4462 159.1096,201.4542 159.1046,201.4622 C159.0846,201.4902 159.0576,201.5152 159.0296,201.5362 C159.0016,201.5582 158.9706,201.5762 158.9386,201.5922 C158.9076,201.6082 158.8746,201.6222 158.8416,201.6352",
    id: "Stroke-333",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8418,201.0908 C158.8748,201.1038 158.9078,201.1178 158.9388,201.1338 C158.9698,201.1498 159.0018,201.1678 159.0298,201.1898 C159.0578,201.2108 159.0848,201.2358 159.1048,201.2638 C159.1098,201.2718 159.1148,201.2788 159.1188,201.2878 C159.1228,201.2948 159.1268,201.3028 159.1298,201.3108 C159.1348,201.3278 159.1388,201.3448 159.1388,201.3628",
    id: "Stroke-335",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.5161,
    y1: 220.4946,
    x2: 209.8831,
    y2: 224.5296,
    id: "Stroke-337",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8652,363.5395 C179.8652,363.5525 179.8642,363.5635 179.8622,363.5765",
    id: "Stroke-339",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.8061,
    y1: 362.6088,
    x2: 177.7461,
    y2: 362.9988,
    id: "Stroke-341",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8676,363.5083 C179.8676,363.5193 179.8666,363.5293 179.8656,363.5393",
    id: "Stroke-343",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.2915,363.5083 C177.2915,363.4863 177.2935,363.4633 177.2975,363.4413",
    id: "Stroke-345",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8623,363.5766 C179.8603,363.5896 179.8573,363.6026 179.8533,363.6156 C179.8483,363.6326 179.8433,363.6486 179.8363,363.6656 C179.8313,363.6786 179.8253,363.6906 179.8193,363.7026 C179.8133,363.7136 179.8073,363.7226 179.8013,363.7326 C179.7953,363.7436 179.7883,363.7536 179.7803,363.7636 C179.7793,363.7656 179.7783,363.7676 179.7773,363.7686 C179.7703,363.7786 179.7623,363.7866 179.7553,363.7956 C179.7453,363.8066 179.7353,363.8176 179.7243,363.8286 C179.7153,363.8386 179.7063,363.8466 179.6963,363.8546 C179.6933,363.8576 179.6903,363.8606 179.6863,363.8636 C179.6673,363.8796 179.6473,363.8946 179.6263,363.9086 C179.6103,363.9206 179.5923,363.9306 179.5753,363.9406 C179.5583,363.9516 179.5403,363.9616 179.5223,363.9706 C179.5033,363.9796 179.4843,363.9886 179.4653,363.9976 C179.4453,364.0056 179.4253,364.0136 179.4053,364.0216 C179.3843,364.0296 179.3643,364.0366 179.3423,364.0446 C179.3213,364.0516 179.3003,364.0576 179.2783,364.0636 C179.2563,364.0706 179.2343,364.0766 179.2113,364.0826 C179.1883,364.0876 179.1653,364.0936 179.1423,364.0976 C179.1193,364.1026 179.0953,364.1076 179.0713,364.1116 C179.0253,364.1206 178.9773,364.1276 178.9283,364.1336 C178.9043,364.1376 178.8813,364.1386 178.8563,364.1416 C178.8093,364.1456 178.7613,364.1496 178.7133,364.1516 C178.6903,364.1526 178.6663,364.1536 178.6433,364.1536 C178.5973,364.1546 178.5523,364.1546 178.5073,364.1536 C178.4613,364.1526 178.4163,364.1506 178.3713,364.1466 C178.3483,364.1456 178.3253,364.1436 178.3023,364.1416 C178.2553,364.1376 178.2083,364.1316 178.1623,364.1246 C178.1393,364.1206 178.1153,364.1176 178.0923,364.1126 C178.0703,364.1086 178.0473,364.1036 178.0243,364.0996 C178.0163,364.0976 178.0093,364.0966 178.0023,364.0956 C177.9643,364.0866 177.9253,364.0766 177.8893,364.0666 C177.8553,364.0566 177.8213,364.0466 177.7903,364.0346 C177.7593,364.0236 177.7303,364.0126 177.7023,364.0006 C177.6823,363.9916 177.6633,363.9826 177.6443,363.9736 C177.6233,363.9636 177.6023,363.9516 177.5823,363.9396 C177.5603,363.9276 177.5403,363.9146 177.5203,363.8996 C177.5043,363.8886 177.4873,363.8766 177.4723,363.8636 C177.4633,363.8546 177.4533,363.8466 177.4443,363.8376 C177.4403,363.8346 177.4373,363.8316 177.4343,363.8286 C177.4303,363.8246 177.4263,363.8206 177.4223,363.8156 C177.4153,363.8086 177.4083,363.8016 177.4023,363.7936 C177.3943,363.7836 177.3863,363.7736 177.3783,363.7636 C177.3713,363.7536 177.3643,363.7436 177.3573,363.7326 C177.3513,363.7226 177.3453,363.7136 177.3403,363.7026 C177.3333,363.6886 177.3263,363.6756 177.3213,363.6616 C177.3173,363.6506 177.3143,363.6406 177.3103,363.6316 C177.3063,363.6166 177.3023,363.6026 177.2993,363.5886 C177.2983,363.5796 177.2963,363.5696 177.2953,363.5606 C177.2943,363.5526 177.2933,363.5436 177.2923,363.5346 C177.2923,363.5256 177.2913,363.5166 177.2913,363.5086",
    id: "Stroke-347",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.8061,362.977 C177.8061,362.976 177.8061,362.976 177.8071,362.976",
    id: "Stroke-349",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.166,
    y1: 361.9038,
    x2: 182.166,
    y2: 329.8138,
    id: "Stroke-351",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.9931,360.478 C174.9931,360.508 174.9941,360.538 174.9961,360.568 C174.9991,360.599 175.0021,360.631 175.0061,360.663 C175.0151,360.724 175.0281,360.785 175.0441,360.844 C175.0761,360.963 175.1231,361.08 175.1831,361.187 C175.2131,361.241 175.2471,361.293 175.2841,361.342 C175.3031,361.368 175.3231,361.393 175.3431,361.416 C175.3631,361.439 175.3831,361.461 175.4051,361.483 C175.4271,361.505 175.4511,361.527 175.4751,361.547 C175.4981,361.567 175.5221,361.584 175.5471,361.602 C175.5741,361.62 175.6011,361.637 175.6301,361.652 C175.6561,361.665 175.6831,361.678 175.7101,361.688",
    id: "Stroke-353",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.8086,
    y1: 362.5795,
    x2: 180.1006,
    y2: 363.2275,
    id: "Stroke-355",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.8086,362.5795 C181.8726,362.5555 181.9286,362.5175 181.9756,362.4675 C182.0236,362.4185 182.0596,362.3605 182.0886,362.2995 C182.1166,362.2375 182.1356,362.1725 182.1476,362.1055 C182.1606,362.0395 182.1656,361.9715 182.1656,361.9035",
    id: "Stroke-357",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.458,
    y1: 362.5512,
    x2: 180.458,
    y2: 329.1662,
    id: "Stroke-359",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.101,363.228 C180.165,363.204 180.221,363.165 180.268,363.116 C180.315,363.067 180.352,363.009 180.38,362.948 C180.409,362.886 180.428,362.82 180.44,362.753 C180.453,362.687 180.458,362.619 180.458,362.551",
    id: "Stroke-361",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.9599,
    y1: 317.9917,
    x2: 286.9599,
    y2: 296.8947,
    id: "Stroke-363",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.6772,319.2016 C287.6502,319.1916 287.6222,319.1796 287.5962,319.1656 C287.5682,319.1506 287.5402,319.1336 287.5132,319.1156 C287.4892,319.0976 287.4652,319.0806 287.4422,319.0606 C287.4182,319.0406 287.3942,319.0186 287.3712,318.9966 C287.3502,318.9746 287.3292,318.9526 287.3102,318.9306 C287.2892,318.9056 287.2692,318.8816 287.2512,318.8556 C287.2142,318.8066 287.1802,318.7546 287.1502,318.7006 C287.0902,318.5936 287.0432,318.4756 287.0102,318.3576 C286.9942,318.2986 286.9822,318.2376 286.9732,318.1766 C286.9692,318.1446 286.9652,318.1126 286.9632,318.0816 C286.9612,318.0516 286.9602,318.0206 286.9602,317.9916",
    id: "Stroke-365",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.1328,319.4174 C294.1328,319.4844 294.1278,319.5524 294.1148,319.6184 C294.1028,319.6854 294.0828,319.7514 294.0548,319.8134 C294.0268,319.8744 293.9898,319.9324 293.9428,319.9804 C293.8958,320.0304 293.8398,320.0684 293.7758,320.0934",
    id: "Stroke-367",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.7754,
    y1: 320.0932,
    x2: 292.0674,
    y2: 320.7402,
    id: "Stroke-369",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.4253,320.0649 C292.4253,320.1319 292.4193,320.2009 292.4073,320.2669 C292.3943,320.3339 292.3753,320.3989 292.3473,320.4609 C292.3193,320.5219 292.2823,320.5809 292.2353,320.6289 C292.1883,320.6779 292.1323,320.7169 292.0683,320.7409",
    id: "Stroke-371",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.7573,363.2241 C179.7653,363.2341 179.7733,363.2441 179.7803,363.2531 C179.7883,363.2631 179.7953,363.2741 179.8013,363.2851 C179.8073,363.2941 179.8133,363.3041 179.8193,363.3151 C179.8263,363.3281 179.8323,363.3411 179.8383,363.3561 C179.8413,363.3661 179.8453,363.3761 179.8493,363.3861 C179.8533,363.4001 179.8573,363.4141 179.8603,363.4291 C179.8613,363.4381 179.8633,363.4471 179.8643,363.4561 C179.8653,363.4641 179.8663,363.4741 179.8673,363.4831 C179.8673,363.4921 179.8673,363.4991 179.8673,363.5081",
    id: "Stroke-373",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.0732,
    y1: 7.329,
    x2: 129.4942,
    y2: 6.789,
    id: "Stroke-375",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.0732,
    y1: 7.329,
    x2: 128.0732,
    y2: 22.078,
    id: "Stroke-377",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.4013,22.7739 C128.3883,22.7639 128.3763,22.7539 128.3633,22.7429 C128.3513,22.7319 128.3393,22.7199 128.3273,22.7079 C128.3033,22.6839 128.2823,22.6589 128.2623,22.6319 C128.2223,22.5799 128.1883,22.5219 128.1603,22.4619 C128.1333,22.4019 128.1113,22.3389 128.0963,22.2739 C128.0813,22.2099 128.0733,22.1439 128.0733,22.0779",
    id: "Stroke-379",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.4013,
    y1: 22.7739,
    x2: 128.4153,
    y2: 22.7849,
    id: "Stroke-381",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5288,253.3891 C15.5558,253.3791 15.5828,253.3691 15.6108,253.3621 C15.6408,253.3521 15.6718,253.3441 15.7028,253.3361 C15.7318,253.3291 15.7598,253.3241 15.7888,253.3181 C15.8208,253.3121 15.8508,253.3071 15.8818,253.3021 C16.0018,253.2851 16.1248,253.2771 16.2458,253.2771 C16.3658,253.2771 16.4898,253.2851 16.6098,253.3021 C16.6398,253.3071 16.6718,253.3121 16.7018,253.3181 C16.7318,253.3241 16.7598,253.3291 16.7888,253.3361 C16.8198,253.3441 16.8508,253.3521 16.8818,253.3621 C16.9088,253.3691 16.9358,253.3791 16.9628,253.3891",
    id: "Stroke-383",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.1069,
    y1: 260.3696,
    x2: 3.1069,
    y2: 256.6516,
    id: "Stroke-385",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.1689,
    y1: 279.8217,
    x2: 64.1689,
    y2: 283.5407,
    id: "Stroke-387",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2871,254.4311 C19.2871,254.4491 19.2841,254.4661 19.2771,254.4831 C19.2741,254.4911 19.2711,254.4981 19.2671,254.5061 C19.2631,254.5141 19.2581,254.5221 19.2531,254.5301 C19.2321,254.5591 19.2051,254.5831 19.1781,254.6041 C19.1491,254.6251 19.1181,254.6441 19.0871,254.6601 C19.0561,254.6761 19.0231,254.6901 18.9901,254.7021",
    id: "Stroke-389",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.124,
    y1: 329.4174,
    x2: 131.123,
    y2: 310.4454,
    id: "Stroke-391",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.124,
    y1: 308.0922,
    x2: 103.023,
    y2: 299.7822,
    id: "Stroke-393",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6645,
    y1: 277.2807,
    x2: 77.8225,
    y2: 278.3587,
    id: "Stroke-395",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.8227,
    y1: 330.7973,
    x2: 15.0147,
    y2: 306.9643,
    id: "Stroke-397",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.8227,
    y1: 330.7973,
    x2: 80.6647,
    y2: 329.7183,
    id: "Stroke-399",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6645,
    y1: 277.2807,
    x2: 80.7715,
    y2: 277.2397,
    id: "Stroke-401",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6645,
    y1: 307.8657,
    x2: 102.4935,
    y2: 299.5827,
    id: "Stroke-403",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6645,
    y1: 308.1372,
    x2: 81.1235,
    y2: 308.0922,
    id: "Stroke-405",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.5566,
    y1: 59.1005,
    x2: 35.5566,
    y2: 89.0645,
    id: "Stroke-407",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.1357,
    y1: 59.6401,
    x2: 35.5567,
    y2: 59.1001,
    id: "Stroke-409",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.6806,
    y1: 48.4628,
    x2: 6.1016,
    y2: 47.9238,
    id: "Stroke-411",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.6806,
    y1: 48.4628,
    x2: 4.6806,
    y2: 87.4898,
    id: "Stroke-413",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3808,200.3217 C155.4068,200.3117 155.4348,200.3017 155.4628,200.2937 C155.4928,200.2847 155.5238,200.2767 155.5548,200.2687 C155.5838,200.2617 155.6118,200.2557 155.6408,200.2507 C155.6718,200.2447 155.7028,200.2387 155.7338,200.2347 C155.8538,200.2177 155.9768,200.2087 156.0978,200.2087 C156.2178,200.2087 156.3418,200.2177 156.4618,200.2347 C156.4928,200.2387 156.5238,200.2447 156.5538,200.2507 C156.5828,200.2557 156.6118,200.2617 156.6408,200.2687 C156.6718,200.2767 156.7028,200.2847 156.7338,200.2937 C156.7608,200.3017 156.7878,200.3117 156.8148,200.3217",
    id: "Stroke-415",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.1689,
    y1: 283.5405,
    x2: 77.8229,
    y2: 278.3585,
    id: "Stroke-417",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.8252,
    y1: 11.9457,
    x2: 161.2452,
    y2: 11.4067,
    id: "Stroke-419",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.1801,
    y1: 4.872,
    x2: 130.3691,
    y2: 0.769,
    id: "Stroke-421",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5859,
    y1: 261.31,
    x2: 5.5859,
    y2: 267.159,
    id: "Stroke-423",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.0283,
    y1: 7.372,
    x2: 131.0283,
    y2: 7.363,
    id: "Stroke-425",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.0605,
    y1: 253.8989,
    x2: 29.0605,
    y2: 224.8619,
    id: "Stroke-427",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.039,
    y1: 269.101,
    x2: 15.039,
    y2: 306.955,
    id: "Stroke-429",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6645,
    y1: 329.5278,
    x2: 81.0395,
    y2: 329.3848,
    id: "Stroke-431",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.8418,
    y1: 320.1098,
    x2: 289.7728,
    y2: 320.1228,
    id: "Stroke-433",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7241,320.7377 C291.7321,320.7467 291.7401,320.7567 291.7471,320.7667 C291.7551,320.7767 291.7621,320.7867 291.7681,320.7987 C291.7751,320.8077 291.7801,320.8177 291.7861,320.8277 C291.7931,320.8417 291.7991,320.8547 291.8051,320.8697 C291.8091,320.8797 291.8121,320.8887 291.8161,320.8997 C291.8201,320.9137 291.8241,320.9277 291.8271,320.9427 C291.8281,320.9517 291.8301,320.9607 291.8311,320.9687 C291.8321,320.9777 291.8331,320.9877 291.8341,320.9967 C291.8341,321.0057 291.8341,321.0127 291.8341,321.0217",
    id: "Stroke-435",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.1796,
    y1: 86.4247,
    x2: 274.1796,
    y2: 86.4247,
    id: "Stroke-437",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.0923,
    y1: 98.8271,
    x2: 17.0923,
    y2: 251.3441,
    id: "Stroke-439",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.2641,
    y1: 101.5488,
    x2: 24.2641,
    y2: 252.0798,
    id: "Stroke-441",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.9258,
    y1: 103.3178,
    x2: 28.9258,
    y2: 253.8478,
    id: "Stroke-443",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.4541,
    y1: 197.3242,
    x2: 159.4541,
    y2: 152.8472,
    id: "Stroke-445",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.9443,
    y1: 198.2768,
    x2: 156.9443,
    y2: 151.8948,
    id: "Stroke-447",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.2226,
    y1: 198.9301,
    x2: 155.2226,
    y2: 151.2421,
    id: "Stroke-449",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.7924,
    y1: 199.0932,
    x2: 154.7924,
    y2: 151.0782,
    id: "Stroke-451",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.2822,
    y1: 200.0459,
    x2: 152.2822,
    y2: 150.1259,
    id: "Stroke-453",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.561,
    y1: 200.6992,
    x2: 150.561,
    y2: 149.4732,
    id: "Stroke-455",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.1308,
    y1: 200.8623,
    x2: 150.1308,
    y2: 149.3093,
    id: "Stroke-457",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.6206,
    y1: 201.8149,
    x2: 147.6206,
    y2: 148.3569,
    id: "Stroke-459",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.0473,
    y1: 267.3334,
    x2: 6.0473,
    y2: 310.3854,
    id: "Stroke-461",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.8994,
    y1: 202.4682,
    x2: 145.8994,
    y2: 147.7042,
    id: "Stroke-463",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.4692,
    y1: 202.6313,
    x2: 145.4692,
    y2: 147.5403,
    id: "Stroke-465",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.3769,
    y1: 259.7114,
    x2: 48.8739,
    y2: 258.0054,
    id: "Stroke-467",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.874,
    y1: 259.0834,
    x2: 45.798,
    y2: 260.2504,
    id: "Stroke-469",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.1069,
    y1: 260.3696,
    x2: 3.1069,
    y2: 312.8076,
    id: "Stroke-471",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.4858,
    y1: 299.5795,
    x2: 84.1938,
    y2: 306.5195,
    id: "Stroke-473",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.7827,
    y1: 226.3891,
    x2: 220.5157,
    y2: 224.2131,
    id: "Stroke-475",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.0639,
    y1: 208.562,
    x2: 146.2379,
    y2: 208.628,
    id: "Stroke-477",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.6504,
    y1: 90.664,
    x2: 119.6504,
    y2: 61.751,
    id: "Stroke-479",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.6504,
    y1: 188.7094,
    x2: 119.6504,
    y2: 137.7434,
    id: "Stroke-481",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.9292,
    y1: 90.0107,
    x2: 117.9292,
    y2: 62.4047,
    id: "Stroke-483",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.9292,
    y1: 189.3627,
    x2: 117.9292,
    y2: 137.0907,
    id: "Stroke-485",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.9887,
    y1: 88.895,
    x2: 114.9887,
    y2: 63.52,
    id: "Stroke-487",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.9887,
    y1: 190.4785,
    x2: 114.9887,
    y2: 135.9745,
    id: "Stroke-489",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.2676,
    y1: 88.2416,
    x2: 113.2676,
    y2: 64.1726,
    id: "Stroke-491",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.2676,
    y1: 191.1318,
    x2: 113.2676,
    y2: 135.3218,
    id: "Stroke-493",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.3266,
    y1: 87.1259,
    x2: 110.3266,
    y2: 65.2889,
    id: "Stroke-495",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.3266,
    y1: 192.2475,
    x2: 110.3266,
    y2: 134.2055,
    id: "Stroke-497",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.9931,
    y1: 327.0922,
    x2: 174.9931,
    y2: 360.4782,
    id: "Stroke-499",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.9599,
    y1: 281.5161,
    x2: 286.9599,
    y2: 281.5021,
    id: "Stroke-501",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.1328,
    y1: 294.1733,
    x2: 294.1328,
    y2: 319.4173,
    id: "Stroke-503",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.1328,
    y1: 278.7807,
    x2: 294.1328,
    y2: 278.7947,
    id: "Stroke-505",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.4253,
    y1: 294.8217,
    x2: 292.4253,
    y2: 320.0647,
    id: "Stroke-507",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.4253,
    y1: 279.4292,
    x2: 292.4253,
    y2: 279.4422,
    id: "Stroke-509",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.1455,
    y1: 96.9228,
    x2: 136.1455,
    y2: 55.4918,
    id: "Stroke-511",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.1455,
    y1: 183.6479,
    x2: 136.1455,
    y2: 144.0029,
    id: "Stroke-513",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.5908,
    y1: 91.7797,
    x2: 122.5908,
    y2: 60.6347,
    id: "Stroke-515",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.5908,
    y1: 187.5937,
    x2: 122.5908,
    y2: 138.8597,
    id: "Stroke-517",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.0327,
    y1: 120.0541,
    x2: 73.0327,
    y2: 206.3991,
    id: "Stroke-519",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.6499,
    y1: 117.6323,
    x2: 66.6499,
    y2: 208.8203,
    id: "Stroke-521",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.9731,
    y1: 121.1703,
    x2: 75.9731,
    y2: 205.2823,
    id: "Stroke-523",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.6948,
    y1: 121.8232,
    x2: 77.6948,
    y2: 204.6302,
    id: "Stroke-525",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.3711,
    y1: 118.2856,
    x2: 68.3711,
    y2: 208.1676,
    id: "Stroke-527",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.665,
    y1: 112.3256,
    x2: 52.665,
    y2: 214.1276,
    id: "Stroke-529",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.3266,
    y1: 114.0947,
    x2: 57.3266,
    y2: 212.3587,
    id: "Stroke-531",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.9883,
    y1: 115.8637,
    x2: 61.9883,
    y2: 210.5897,
    id: "Stroke-533",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.3857,
    y1: 112.9789,
    x2: 54.3857,
    y2: 213.4739,
    id: "Stroke-535",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.0478,
    y1: 114.7475,
    x2: 59.0478,
    y2: 211.7055,
    id: "Stroke-537",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.7094,
    y1: 116.5165,
    x2: 63.7094,
    y2: 209.9365,
    id: "Stroke-539",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.1357,
    y1: 89.6035,
    x2: 34.1357,
    y2: 59.6405,
    id: "Stroke-541",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.896,
    y1: 113.9311,
    x2: 56.896,
    y2: 212.5221,
    id: "Stroke-543",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.5576,
    y1: 115.7001,
    x2: 61.5576,
    y2: 210.7531,
    id: "Stroke-545",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.2197,
    y1: 117.4692,
    x2: 66.2197,
    y2: 208.9842,
    id: "Stroke-547",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.6352,
    y1: 95.9706,
    x2: 133.6352,
    y2: 56.4446,
    id: "Stroke-549",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.6352,
    y1: 183.4028,
    x2: 133.6352,
    y2: 143.0508,
    id: "Stroke-551",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.9145,
    y1: 95.3173,
    x2: 131.9145,
    y2: 57.0973,
    id: "Stroke-553",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.9145,
    y1: 184.0561,
    x2: 131.9145,
    y2: 142.3971,
    id: "Stroke-555",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.9736,
    y1: 94.2016,
    x2: 128.9736,
    y2: 58.2136,
    id: "Stroke-557",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.9736,
    y1: 185.1718,
    x2: 128.9736,
    y2: 141.2818,
    id: "Stroke-559",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.2524,
    y1: 93.5483,
    x2: 127.2524,
    y2: 58.8663,
    id: "Stroke-561",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.2524,
    y1: 185.8247,
    x2: 127.2524,
    y2: 140.6287,
    id: "Stroke-563",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.312,
    y1: 92.4326,
    x2: 124.312,
    y2: 59.9816,
    id: "Stroke-565",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.312,
    y1: 186.9409,
    x2: 124.312,
    y2: 139.5129,
    id: "Stroke-567",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.8813,
    y1: 119.2377,
    x2: 70.8813,
    y2: 207.2157,
    id: "Stroke-569",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.5429,
    y1: 121.0068,
    x2: 75.5429,
    y2: 205.4458,
    id: "Stroke-571",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.2051,
    y1: 122.7758,
    x2: 80.2051,
    y2: 203.6768,
    id: "Stroke-573",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.3115,
    y1: 207.0517,
    x2: 71.3115,
    y2: 119.4017,
    id: "Stroke-575",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.5283,
    y1: 79.2338,
    x2: 89.5283,
    y2: 73.1808,
    id: "Stroke-577",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.5283,
    y1: 200.1396,
    x2: 89.5283,
    y2: 126.3136,
    id: "Stroke-579",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.1899,
    y1: 81.0024,
    x2: 94.1899,
    y2: 71.4124,
    id: "Stroke-581",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.1899,
    y1: 198.3706,
    x2: 94.1899,
    y2: 128.0826,
    id: "Stroke-583",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.6797,
    y1: 80.0502,
    x2: 91.6797,
    y2: 72.3642,
    id: "Stroke-585",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.6797,
    y1: 199.3232,
    x2: 91.6797,
    y2: 127.1302,
    id: "Stroke-587",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.9585,
    y1: 79.3969,
    x2: 89.9585,
    y2: 73.0179,
    id: "Stroke-589",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.9585,
    y1: 199.9765,
    x2: 89.9585,
    y2: 126.4765,
    id: "Stroke-591",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.018,
    y1: 78.2812,
    x2: 87.018,
    y2: 74.1332,
    id: "Stroke-593",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.018,
    y1: 201.0922,
    x2: 87.018,
    y2: 125.3612,
    id: "Stroke-595",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.2969,
    y1: 77.6284,
    x2: 85.2969,
    y2: 74.7864,
    id: "Stroke-597",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.2969,
    y1: 201.7451,
    x2: 85.2969,
    y2: 124.7081,
    id: "Stroke-599",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.8667,
    y1: 77.4648,
    x2: 84.8667,
    y2: 74.9498,
    id: "Stroke-601",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.8667,
    y1: 201.9086,
    x2: 84.8667,
    y2: 124.5446,
    id: "Stroke-603",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.3564,
    y1: 76.5126,
    x2: 82.3564,
    y2: 75.9026,
    id: "Stroke-605",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.3564,
    y1: 203.6772,
    x2: 82.3564,
    y2: 123.5922,
    id: "Stroke-607",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6352,
    y1: 203.5307,
    x2: 80.6352,
    y2: 122.9387,
    id: "Stroke-609",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.875,
    y1: 362.5961,
    x2: 177.806,
    y2: 362.6091,
    id: "Stroke-611",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.1601,
    y1: 91.6161,
    x2: 122.1601,
    y2: 60.7981,
    id: "Stroke-613",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.1601,
    y1: 187.7573,
    x2: 122.1601,
    y2: 138.6963,
    id: "Stroke-615",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.4985,
    y1: 89.8476,
    x2: 117.4985,
    y2: 62.5676,
    id: "Stroke-617",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.4985,
    y1: 189.5258,
    x2: 117.4985,
    y2: 136.9268,
    id: "Stroke-619",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.8369,
    y1: 88.0786,
    x2: 112.8369,
    y2: 64.3366,
    id: "Stroke-621",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.8369,
    y1: 191.2949,
    x2: 112.8369,
    y2: 135.1579,
    id: "Stroke-623",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.6054,
    y1: 86.4726,
    x2: 108.6054,
    y2: 65.9416,
    id: "Stroke-625",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.6054,
    y1: 192.9003,
    x2: 108.6054,
    y2: 133.5523,
    id: "Stroke-627",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.4838,
    y1: 95.1537,
    x2: 131.4838,
    y2: 57.2607,
    id: "Stroke-629",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.4838,
    y1: 184.2192,
    x2: 131.4838,
    y2: 142.2342,
    id: "Stroke-631",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.8222,
    y1: 93.3852,
    x2: 126.8222,
    y2: 59.0302,
    id: "Stroke-633",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.8222,
    y1: 185.9882,
    x2: 126.8222,
    y2: 140.4652,
    id: "Stroke-635",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.5136,
    y1: 84.5405,
    x2: 103.5136,
    y2: 67.8735,
    id: "Stroke-637",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.4541,
    y1: 46.7119,
    x2: 269.1451,
    y2: 88.3349,
    id: "Stroke-639",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.5512,
    y1: 43.7133,
    x2: 159.4542,
    y2: 46.7123,
    id: "Stroke-641",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.7744,
    y1: 161.309,
    x2: 1.3004,
    y2: 88.653,
    id: "Stroke-643",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.1098,
    y1: 89.9462,
    x2: 191.9678,
    y2: 161.6102,
    id: "Stroke-645",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5327,
    y1: 82.8764,
    x2: 192.2777,
    y2: 149.5644,
    id: "Stroke-647",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.9106,
    y1: 108.6244,
    x2: 42.9106,
    y2: 217.8284,
    id: "Stroke-649",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.875,
    y1: 362.5092,
    x2: 177.875,
    y2: 362.5962,
    id: "Stroke-651",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.1328,
    y1: 294.1733,
    x2: 310.9748,
    y2: 287.7823,
    id: "Stroke-653",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.9599,
    y1: 296.895,
    x2: 294.1329,
    y2: 294.173,
    id: "Stroke-655",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.1147,
    y1: 333.2641,
    x2: 286.9597,
    y2: 296.8951,
    id: "Stroke-657",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.6938,
    y1: 332.725,
    x2: 189.6938,
    y2: 318.424,
    id: "Stroke-661",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.9751,
    y1: 273.4819,
    x2: 191.1151,
    y2: 318.9629,
    id: "Stroke-663",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.6938,
    y1: 318.4243,
    x2: 309.5538,
    y2: 272.9423,
    id: "Stroke-665",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8725,
    y1: 269.9233,
    x2: 12.8725,
    y2: 264.0753,
    id: "Stroke-667",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.9404,
    y1: 269.1391,
    x2: 12.8724,
    y2: 269.9231,
    id: "Stroke-669",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5859,
    y1: 267.1586,
    x2: 12.8729,
    y2: 269.9236,
    id: "Stroke-671",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.5527,
    y1: 76.2075,
    x2: 151.5517,
    y2: 49.6455,
    id: "Stroke-673",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.5512,
    y1: 49.6459,
    x2: 151.5512,
    y2: 15.0839,
    id: "Stroke-675",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.3842,
    y1: 22.7973,
    x2: 150.1302,
    y2: 14.5453,
    id: "Stroke-677",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.9009,
    y1: 54.8549,
    x2: 128.3839,
    y2: 22.7969,
    id: "Stroke-679",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.4087,
    y1: 55.4213,
    x2: 43.9007,
    y2: 54.8553,
    id: "Stroke-681",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.5512,
    y1: 15.0844,
    x2: 43.8292,
    y2: 55.9604,
    id: "Stroke-683",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.9077,
    y1: 161.6401,
    x2: 347.5147,
    y2: 102.5941,
    id: "Stroke-685",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.8852,
    y1: 102.4448,
    x2: 192.3942,
    y2: 161.8258,
    id: "Stroke-687",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.9077,
    y1: 165.309,
    x2: 191.9077,
    y2: 161.64,
    id: "Stroke-689",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.48,
    y1: 55.394,
    x2: 21.942,
    y2: 47.601,
    id: "Stroke-691",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.3633,
    y1: 47.0615,
    x2: 43.9013,
    y2: 54.8545,
    id: "Stroke-693",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.5273,
    y1: 90.2255,
    x2: 316.5273,
    y2: 102.4155,
    id: "Stroke-695",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.5273,
    y1: 71.414,
    x2: 316.5273,
    y2: 90.226,
    id: "Stroke-697",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.6074,
    y1: 317.3188,
    x2: 80.7724,
    y2: 274.8808,
    id: "Stroke-699",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.1225,
    y1: 310.4458,
    x2: 80.6645,
    y2: 291.2998,
    id: "Stroke-701",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.9931,
    y1: 327.0922,
    x2: 131.1221,
    y2: 310.4462,
    id: "Stroke-703",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.166,
    y1: 329.8139,
    x2: 174.993,
    y2: 327.0919,
    id: "Stroke-705",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.6938,
    y1: 332.6704,
    x2: 182.1658,
    y2: 329.8144,
    id: "Stroke-707",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.7719,
    y1: 277.0385,
    x2: 189.7659,
    y2: 318.3965,
    id: "Stroke-709",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.626,236.5092 C49.638,236.5082 49.65,236.5082 49.663,236.5082 L49.685,236.5082 C49.697,236.5092 49.709,236.5102 49.722,236.5112 C49.731,236.5122 49.741,236.5142 49.751,236.5152 C49.771,236.5182 49.79,236.5212 49.809,236.5262 C49.819,236.5282 49.829,236.5302 49.839,236.5332 C49.851,236.5362 49.862,236.5402 49.874,236.5442 C49.891,236.5492 49.908,236.5562 49.924,236.5642 C49.952,236.5752 49.98,236.5882 50.006,236.6042 C50.015,236.6092 50.023,236.6142 50.032,236.6192 C50.049,236.6302 50.065,236.6422 50.082,236.6552 C50.09,236.6602 50.098,236.6662 50.105,236.6732 C50.121,236.6862 50.136,236.6982 50.151,236.7122 C50.173,236.7332 50.193,236.7552 50.213,236.7782 C50.251,236.8212 50.286,236.8692 50.315,236.9212 C50.33,236.9462 50.343,236.9712 50.355,236.9972 C50.368,237.0232 50.378,237.0482 50.389,237.0742 C50.398,237.1002 50.407,237.1252 50.415,237.1522 C50.418,237.1612 50.42,237.1702 50.423,237.1792 C50.427,237.1962 50.432,237.2122 50.436,237.2292 C50.441,237.2552 50.446,237.2802 50.45,237.3072 C50.455,237.3342 50.458,237.3622 50.46,237.3892 C50.463,237.4172 50.464,237.4462 50.465,237.4742 C50.465,237.5032 50.464,237.5312 50.463,237.5612 C50.461,237.5902 50.459,237.6192 50.455,237.6492 C50.451,237.6792 50.445,237.7082 50.439,237.7382 C50.433,237.7672 50.425,237.7962 50.417,237.8252 C50.408,237.8552 50.398,237.8832 50.387,237.9112 C50.364,237.9682 50.337,238.0222 50.306,238.0712 C50.29,238.0972 50.273,238.1212 50.255,238.1452 C50.237,238.1682 50.218,238.1902 50.198,238.2112 C50.185,238.2252 50.171,238.2382 50.157,238.2512 C50.15,238.2572 50.143,238.2642 50.135,238.2702 C50.113,238.2882 50.091,238.3052 50.068,238.3212 C50.053,238.3302 50.038,238.3402 50.023,238.3492 C50.015,238.3542 50.006,238.3592 49.997,238.3632 C49.973,238.3752 49.949,238.3862 49.923,238.3962",
    id: "Stroke-711",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9409,228.4213 C70.9529,228.4203 70.9649,228.4203 70.9779,228.4203 L70.9999,228.4203 C71.0119,228.4213 71.0239,228.4223 71.0369,228.4233 C71.0459,228.4243 71.0559,228.4253 71.0659,228.4273 C71.0859,228.4293 71.1049,228.4333 71.1239,228.4383 C71.1329,228.4403 71.1439,228.4423 71.1539,228.4453 C71.1659,228.4483 71.1769,228.4513 71.1889,228.4553 C71.2059,228.4613 71.2229,228.4683 71.2389,228.4753 C71.2669,228.4863 71.2949,228.5003 71.3209,228.5163 C71.3299,228.5213 71.3379,228.5263 71.3469,228.5313 C71.3639,228.5423 71.3799,228.5543 71.3969,228.5673 C71.4049,228.5723 71.4129,228.5783 71.4199,228.5853 C71.4359,228.5973 71.4509,228.6103 71.4659,228.6243 C71.4879,228.6453 71.5079,228.6663 71.5279,228.6903 C71.5659,228.7333 71.5999,228.7813 71.6299,228.8333 C71.6449,228.8583 71.6579,228.8833 71.6699,228.9093 C71.6829,228.9353 71.6929,228.9603 71.7039,228.9863 C71.7129,229.0123 71.7219,229.0373 71.7299,229.0643 C71.7329,229.0723 71.7349,229.0823 71.7379,229.0913 C71.7419,229.1083 71.7469,229.1243 71.7499,229.1413 C71.7559,229.1663 71.7609,229.1923 71.7649,229.2193 C71.7699,229.2463 71.7729,229.2743 71.7749,229.3013 C71.7779,229.3293 71.7789,229.3583 71.7799,229.3853 C71.7799,229.4143 71.7789,229.4433 71.7779,229.4733 C71.7759,229.5023 71.7739,229.5313 71.7699,229.5613 C71.7649,229.5913 71.7599,229.6203 71.7539,229.6503 C71.7479,229.6793 71.7399,229.7083 71.7319,229.7373 C71.7229,229.7663 71.7129,229.7953 71.7019,229.8223 C71.6789,229.8793 71.6519,229.9343 71.6209,229.9833 C71.6049,230.0093 71.5879,230.0333 71.5699,230.0573 C71.5519,230.0803 71.5329,230.1023 71.5119,230.1233 C71.4999,230.1373 71.4859,230.1503 71.4719,230.1623 C71.4649,230.1693 71.4569,230.1763 71.4499,230.1823 C71.4279,230.2003 71.4059,230.2173 71.3819,230.2333 C71.3679,230.2423 71.3529,230.2523 71.3379,230.2603 C71.3289,230.2653 71.3209,230.2703 71.3119,230.2753 C71.2879,230.2873 71.2629,230.2983 71.2379,230.3083",
    id: "Stroke-713",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5981,224.3774 C81.6101,224.3764 81.6231,224.3764 81.6351,224.3764 L81.6571,224.3764 L81.6941,224.3794 C81.7031,224.3804 81.7141,224.3814 81.7231,224.3834 C81.7431,224.3854 81.7621,224.3894 81.7811,224.3944 C81.7911,224.3964 81.8011,224.3984 81.8111,224.4004 C81.8231,224.4044 81.8341,224.4074 81.8461,224.4114 C81.8631,224.4174 81.8801,224.4244 81.8971,224.4314 C81.9251,224.4424 81.9521,224.4564 81.9781,224.4724 C81.9871,224.4774 81.9951,224.4824 82.0041,224.4874 C82.0211,224.4984 82.0371,224.5104 82.0541,224.5224 C82.0621,224.5284 82.0701,224.5344 82.0781,224.5404 C82.0941,224.5534 82.1081,224.5664 82.1231,224.5804 C82.1451,224.6014 82.1651,224.6224 82.1851,224.6464 C82.2231,224.6894 82.2581,224.7374 82.2871,224.7894 C82.3021,224.8144 82.3151,224.8394 82.3271,224.8654 C82.3401,224.8904 82.3511,224.9164 82.3611,224.9424 C82.3701,224.9684 82.3791,224.9934 82.3881,225.0204 C82.3901,225.0284 82.3921,225.0384 82.3951,225.0474 C82.4001,225.0644 82.4041,225.0804 82.4081,225.0974 C82.4131,225.1224 82.4181,225.1484 82.4231,225.1754 C82.4271,225.2024 82.4301,225.2294 82.4321,225.2574 C82.4351,225.2854 82.4361,225.3134 82.4371,225.3414 C82.4371,225.3704 82.4371,225.3994 82.4351,225.4294 C82.4331,225.4584 82.4311,225.4874 82.4271,225.5174 C82.4231,225.5464 82.4171,225.5764 82.4111,225.6064 C82.4051,225.6354 82.3971,225.6644 82.3891,225.6934 C82.3801,225.7224 82.3701,225.7514 82.3591,225.7784 C82.3371,225.8354 82.3091,225.8904 82.2781,225.9394 C82.2621,225.9654 82.2451,225.9894 82.2271,226.0134 C82.2091,226.0354 82.1901,226.0584 82.1701,226.0794 C82.1571,226.0934 82.1431,226.1064 82.1291,226.1184 C82.1221,226.1254 82.1151,226.1324 82.1071,226.1384 C82.0861,226.1564 82.0631,226.1734 82.0401,226.1894 C82.0251,226.1984 82.0111,226.2074 81.9951,226.2164 C81.9871,226.2214 81.9781,226.2264 81.9691,226.2314 C81.9451,226.2434 81.9211,226.2544 81.8961,226.2644",
    id: "Stroke-715",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.8042,
    y1: 228.4272,
    x2: 70.9412,
    y2: 228.4212,
    id: "Stroke-717",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.8203,
    y1: 206.9814,
    x2: 92.8043,
    y2: 228.9024,
    id: "Stroke-719",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2221,205.1445 C86.2551,205.1565 86.2881,205.1705 86.3211,205.1845 C86.3581,205.2005 86.3941,205.2165 86.4301,205.2345 C86.4931,205.2645 86.5541,205.2965 86.6141,205.3315 C86.7391,205.4055 86.8581,205.4905 86.9691,205.5835 C86.9821,205.5945 86.9941,205.6045 87.0071,205.6155 C87.0721,205.6735 87.1351,205.7335 87.1941,205.7975 C87.2241,205.8305 87.2531,205.8635 87.2821,205.8965 C87.2971,205.9145 87.3111,205.9325 87.3251,205.9505 C87.3461,205.9765 87.3661,206.0025 87.3851,206.0295 C87.4431,206.1075 87.4961,206.1895 87.5441,206.2735 C87.5911,206.3565 87.6341,206.4405 87.6711,206.5275 C87.7351,206.6745 87.7851,206.8265 87.8201,206.9815",
    id: "Stroke-721",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.1943,
    y1: 203.6157,
    x2: 86.2223,
    y2: 205.1447,
    id: "Stroke-723",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.7226,
    y1: 222.4536,
    x2: 80.3666,
    y2: 203.6156,
    id: "Stroke-725",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3667,203.6157 C80.3967,203.6047 80.4277,203.5937 80.4587,203.5827 C80.4917,203.5717 80.5257,203.5607 80.5597,203.5517 C80.6097,203.5367 80.6597,203.5237 80.7107,203.5117 C80.7367,203.5067 80.7627,203.5007 80.7877,203.4957 C80.8607,203.4817 80.9337,203.4707 81.0077,203.4627 C81.0977,203.4527 81.1897,203.4487 81.2807,203.4487 C81.3717,203.4487 81.4637,203.4527 81.5537,203.4627 C81.6277,203.4707 81.7007,203.4817 81.7727,203.4957 C81.7987,203.5007 81.8247,203.5067 81.8507,203.5117 C81.9017,203.5237 81.9507,203.5367 82.0017,203.5517 C82.0347,203.5607 82.0687,203.5717 82.1027,203.5827 C82.1337,203.5937 82.1637,203.6047 82.1947,203.6157",
    id: "Stroke-727",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0605,224.8618 C29.0605,224.6918 29.0775,224.5218 29.1105,224.3558 C29.1465,224.1768 29.2015,224.0038 29.2725,223.8378 C29.3105,223.7508 29.3535,223.6658 29.4005,223.5838 C29.4485,223.4988 29.5015,223.4178 29.5595,223.3388 C29.5795,223.3118 29.5995,223.2858 29.6195,223.2598 C29.6335,223.2418 29.6485,223.2238 29.6635,223.2068 C29.6915,223.1728 29.7205,223.1398 29.7505,223.1068 C29.8105,223.0438 29.8725,222.9828 29.9385,222.9248 L29.9755,222.8928 C30.0865,222.7988 30.2055,222.7158 30.3315,222.6408 C30.3905,222.6058 30.4515,222.5738 30.5145,222.5438 C30.5505,222.5258 30.5865,222.5088 30.6235,222.4938 C30.6565,222.4798 30.6895,222.4658 30.7225,222.4538",
    id: "Stroke-729",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.4541,
    y1: 105.7675,
    x2: 191.3381,
    y2: 117.8665,
    id: "Stroke-731",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9975,
    y1: 51.7114,
    x2: 159.4545,
    y2: 105.7674,
    id: "Stroke-733",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.8833,
    y1: 118.039,
    x2: 16.9143,
    y2: 52.026,
    id: "Stroke-735",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.4541,
    y1: 152.8476,
    x2: 3.1071,
    y2: 93.5206,
    id: "Stroke-737",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.9077,
    y1: 165.1621,
    x2: 159.4537,
    y2: 152.8481,
    id: "Stroke-739",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.2676,212.2866 C113.2456,212.2946 113.2236,212.3046 113.2026,212.3146 C113.1806,212.3266 113.1586,212.3406 113.1386,212.3546 C113.1166,212.3696 113.0956,212.3866 113.0756,212.4036 C113.0546,212.4226 113.0346,212.4416 113.0156,212.4636 C112.9826,212.5006 112.9526,212.5406 112.9256,212.5826 C112.8976,212.6286 112.8736,212.6766 112.8526,212.7246 C112.8336,212.7726 112.8166,212.8216 112.8036,212.8716 C112.7906,212.9216 112.7806,212.9736 112.7746,213.0246 C112.7676,213.0766 112.7646,213.1296 112.7636,213.1826 C112.7636,213.2326 112.7666,213.2836 112.7716,213.3346 C112.7736,213.3476 112.7746,213.3596 112.7766,213.3726 C112.7786,213.3856 112.7806,213.3966 112.7826,213.4096 C112.7876,213.4346 112.7916,213.4606 112.7976,213.4846 C112.8096,213.5366 112.8256,213.5866 112.8436,213.6366 C112.8626,213.6846 112.8846,213.7316 112.9096,213.7776 C112.9346,213.8226 112.9626,213.8656 112.9936,213.9066 C113.0266,213.9486 113.0626,213.9886 113.1036,214.0236 C113.1226,214.0406 113.1426,214.0566 113.1636,214.0706 C113.1836,214.0846 113.2046,214.0976 113.2256,214.1096 C113.2506,214.1226 113.2756,214.1346 113.3016,214.1436 C113.3266,214.1536 113.3506,214.1616 113.3766,214.1676 C113.4016,214.1736 113.4266,214.1776 113.4516,214.1796 C113.4756,214.1826 113.4996,214.1826 113.5236,214.1816",
    id: "Stroke-751",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.228,208.2006 C124.24,208.2006 124.253,208.2006 124.265,208.2006 C124.272,208.2006 124.28,208.2006 124.287,208.2006 C124.299,208.2006 124.311,208.2016 124.324,208.2026 C124.333,208.2036 124.343,208.2056 124.353,208.2066 C124.373,208.2096 124.392,208.2126 124.411,208.2176 C124.421,208.2196 124.431,208.2226 124.441,208.2246 C124.453,208.2286 124.464,208.2316 124.476,208.2356 C124.493,208.2416 124.51,208.2476 124.526,208.2556 C124.554,208.2666 124.582,208.2806 124.608,208.2956 C124.617,208.3016 124.625,208.3056 124.634,208.3116 C124.651,208.3226 124.667,208.3336 124.684,208.3466 C124.692,208.3516 124.7,208.3586 124.707,208.3646 C124.723,208.3776 124.738,208.3906 124.753,208.4046 C124.775,208.4246 124.796,208.4466 124.815,208.4696 C124.853,208.5126 124.888,208.5616 124.917,208.6136 C124.932,208.6376 124.945,208.6626 124.957,208.6896 C124.97,208.7146 124.98,208.7406 124.991,208.7666 C125,208.7916 125.009,208.8176 125.017,208.8446 C125.02,208.8526 125.022,208.8626 125.025,208.8706 C125.029,208.8876 125.034,208.9036 125.038,208.9206 C125.043,208.9466 125.048,208.9726 125.052,208.9986 C125.057,209.0256 125.06,209.0536 125.062,209.0806 C125.065,209.1086 125.066,209.1376 125.067,209.1656 C125.067,209.1946 125.066,209.2236 125.065,209.2526 C125.063,209.2826 125.061,209.3116 125.057,209.3406 C125.053,209.3706 125.047,209.4006 125.041,209.4296 C125.035,209.4596 125.027,209.4886 125.019,209.5166 C125.01,209.5466 125,209.5756 124.989,209.6026 C124.967,209.6596 124.939,209.7136 124.908,209.7636 C124.892,209.7886 124.875,209.8126 124.857,209.8366 C124.839,209.8596 124.82,209.8826 124.8,209.9026 C124.787,209.9166 124.773,209.9296 124.759,209.9426 C124.752,209.9496 124.744,209.9556 124.737,209.9626 C124.715,209.9796 124.693,209.9976 124.669,210.0126 C124.655,210.0226 124.64,210.0316 124.625,210.0406 C124.617,210.0456 124.608,210.0506 124.599,210.0546 C124.575,210.0666 124.55,210.0776 124.525,210.0876",
    id: "Stroke-753",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.7754,
    y1: 202.8945,
    x2: 146.0914,
    y2: 208.6835,
    id: "Stroke-755",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.1074,
    y1: 186.7617,
    x2: 144.7754,
    y2: 202.8947,
    id: "Stroke-757",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5092,184.9238 C139.5422,184.9368 139.5752,184.9498 139.6082,184.9638 C139.6452,184.9798 139.6822,184.9968 139.7172,185.0138 C139.7802,185.0438 139.8412,185.0768 139.9012,185.1118 C140.0272,185.1858 140.1452,185.2698 140.2572,185.3638 C140.2692,185.3748 140.2812,185.3848 140.2942,185.3958 C140.3592,185.4528 140.4222,185.5138 140.4812,185.5778 C140.5112,185.6098 140.5402,185.6428 140.5692,185.6768 C140.5842,185.6948 140.5982,185.7128 140.6122,185.7298 C140.6332,185.7568 140.6532,185.7818 140.6732,185.8088 C140.7302,185.8878 140.7832,185.9688 140.8312,186.0538 C140.8792,186.1358 140.9212,186.2208 140.9592,186.3078 C141.0222,186.4538 141.0722,186.6058 141.1072,186.7618",
    id: "Stroke-759",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.4819,
    y1: 183.3959,
    x2: 139.5089,
    y2: 184.9239,
    id: "Stroke-761",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.0102,
    y1: 202.2334,
    x2: 133.6542,
    y2: 183.3964,
    id: "Stroke-763",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.3178,
    y1: 210.1303,
    x2: 124.1808,
    y2: 210.1373,
    id: "Stroke-765",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1811,210.1372 C124.2381,210.1342 124.2941,210.1222 124.3481,210.1022",
    id: "Stroke-767",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.6411,
    y1: 87.3857,
    x2: 16.5331,
    y2: 82.8737,
    id: "Stroke-769",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 88.957,
    x2: 4.641,
    y2: 87.386,
    id: "Stroke-771",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.2788,
    y1: 193.0283,
    x2: 10.2788,
    y2: 96.2423,
    id: "Stroke-773",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.709,
    y1: 96.4052,
    x2: 10.709,
    y2: 192.8622,
    id: "Stroke-775",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.4302,
    y1: 97.058,
    x2: 12.4302,
    y2: 192.195,
    id: "Stroke-777",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.6172,
    y1: 310.5493,
    x2: 5.6172,
    y2: 311.8553,
    id: "Stroke-779",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.6172,
    y1: 267.1704,
    x2: 5.6172,
    y2: 310.5494,
    id: "Stroke-781",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.7685,
    y1: 203.9287,
    x2: 7.7685,
    y2: 254.8827,
    id: "Stroke-783",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.7685,
    y1: 95.2895,
    x2: 7.7685,
    y2: 194.0005,
    id: "Stroke-785",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.7685,
    y1: 267.9868,
    x2: 7.7685,
    y2: 311.0388,
    id: "Stroke-787",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.2788,
    y1: 202.9565,
    x2: 10.2788,
    y2: 253.9305,
    id: "Stroke-789",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.2788,
    y1: 308.7797,
    x2: 10.2788,
    y2: 310.0867,
    id: "Stroke-791",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.2788,
    y1: 268.9389,
    x2: 10.2788,
    y2: 308.7799,
    id: "Stroke-793",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.709,
    y1: 202.79,
    x2: 10.709,
    y2: 253.767,
    id: "Stroke-795",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.709,
    y1: 269.103,
    x2: 10.709,
    y2: 308.617,
    id: "Stroke-797",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.4302,
    y1: 202.1235,
    x2: 12.4302,
    y2: 253.1135,
    id: "Stroke-799",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.4302,
    y1: 269.7553,
    x2: 12.4302,
    y2: 309.2703,
    id: "Stroke-801",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.9404,
    y1: 306.9926,
    x2: 14.9404,
    y2: 308.3166,
    id: "Stroke-803",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.9404,
    y1: 269.1391,
    x2: 14.9404,
    y2: 306.9931,
    id: "Stroke-805",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.2773,
    y1: 118.5683,
    x2: 189.8113,
    y2: 117.6323,
    id: "Stroke-807",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7651,297.2739 C182.6791,296.4629 176.2201,294.8219 176.2201,294.8219 L62.3551,251.6159",
    id: "Stroke-809",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.227,261.5932 L213.764,292.5052 C213.764,292.5052 208.628,294.6862 203.089,296.2272",
    id: "Stroke-811",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.6728,276.312 C300.6748,276.307 300.6778,276.302 300.6798,276.296",
    id: "Stroke-813",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.7724,
    y1: 270.0434,
    x2: 301.7724,
    y2: 275.4774,
    id: "Stroke-815",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.7724,
    y1: 261.1752,
    x2: 301.7724,
    y2: 270.0432,
    id: "Stroke-817",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.874,
    y1: 261.4174,
    x2: 48.874,
    y2: 247.3514,
    id: "Stroke-819",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.7724,275.477 C301.7724,275.612 301.7614,275.746 301.7414,275.878 C301.7394,275.888 301.7374,275.899 301.7354,275.909",
    id: "Stroke-821",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.5361,
    y1: 244.9418,
    x2: 156.1931,
    y2: 204.8508,
    id: "Stroke-823",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.874,247.351 C48.874,247.216 48.884,247.082 48.905,246.95 C48.929,246.803 48.964,246.659 49.012,246.518 C49.063,246.369 49.127,246.225 49.205,246.088 C49.283,245.948 49.375,245.815 49.479,245.692 C49.547,245.611 49.62,245.535 49.697,245.463 C49.823,245.346 49.961,245.242 50.108,245.152 C50.244,245.069 50.387,244.998 50.536,244.942",
    id: "Stroke-825",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1928,204.8505 C156.3738,204.7815 156.5618,204.7335 156.7528,204.7065 C156.9938,204.6735 157.2388,204.6745 157.4808,204.7095 C157.6648,204.7365 157.8458,204.7845 158.0208,204.8505",
    id: "Stroke-827",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.7827,
    y1: 226.3891,
    x2: 300.1097,
    y2: 258.7671,
    id: "Stroke-829",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.0205,
    y1: 204.8505,
    x2: 214.7825,
    y2: 226.3895,
    id: "Stroke-831",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.5273,
    y1: 71.4345,
    x2: 192.2773,
    y2: 118.5685,
    id: "Stroke-833",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.1455,
    y1: 88.3354,
    x2: 314.6865,
    y2: 71.0544,
    id: "Stroke-835",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.3296,
    y1: 117.8627,
    x2: 269.1456,
    y2: 88.3357,
    id: "Stroke-839",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.039,
    y1: 306.9545,
    x2: 14.94,
    y2: 306.9925,
    id: "Stroke-841",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.7129,
    y1: 320.5122,
    x2: 289.7129,
    y2: 320.4752,
    id: "Stroke-843",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8584,202.582 C150.8254,202.57 150.7924,202.555 150.7604,202.54 C150.7294,202.523 150.6984,202.505 150.6704,202.484 C150.6424,202.463 150.6154,202.438 150.5954,202.409 C150.5894,202.401 150.5854,202.394 150.5814,202.386 C150.5774,202.378 150.5734,202.37 150.5704,202.362 C150.5644,202.345 150.5614,202.328 150.5614,202.31",
    id: "Stroke-845",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.8847,
    y1: 203.351,
    x2: 150.8587,
    y2: 202.582,
    id: "Stroke-847",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.8418,
    y1: 201.6352,
    x2: 154.3198,
    y2: 203.3512,
    id: "Stroke-849",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.8149,
    y1: 200.3217,
    x2: 158.8419,
    y2: 201.0907,
    id: "Stroke-851",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.3808,
    y1: 200.3217,
    x2: 150.8588,
    y2: 202.0377,
    id: "Stroke-853",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.7754,
    y1: 202.8945,
    x2: 159.4544,
    y2: 197.3245,
    id: "Stroke-855",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.1372,
    y1: 206.7685,
    x2: 145.1382,
    y2: 204.4925,
    id: "Stroke-857",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.561,202.31 C150.561,202.292 150.564,202.275 150.57,202.258 C150.573,202.25 150.577,202.242 150.581,202.234 C150.585,202.227 150.59,202.219 150.595,202.211 C150.615,202.182 150.643,202.157 150.67,202.136 C150.698,202.115 150.729,202.097 150.761,202.081 C150.792,202.065 150.825,202.05 150.858,202.038",
    id: "Stroke-859",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.2973,363.4409 C177.2993,363.4269 177.3023,363.4149 177.3063,363.4009 C177.3103,363.3839 177.3163,363.3679 177.3223,363.3519 C177.3283,363.3389 177.3343,363.3269 177.3403,363.3149 C177.3453,363.3039 177.3513,363.2949 177.3573,363.2849 C177.3643,363.2739 177.3713,363.2629 177.3783,363.2539 L177.3823,363.2479 C177.3893,363.2389 177.3963,363.2299 177.4033,363.2209 C177.4133,363.2109 177.4233,363.1989 177.4343,363.1879 C177.4433,363.1789 177.4533,363.1699 177.4633,363.1619 C177.4663,363.1599 177.4693,363.1569 177.4723,363.1539 C177.4913,363.1369 177.5113,363.1229 177.5323,363.1079 C177.5493,363.0969 177.5663,363.0869 177.5843,363.0759 C177.6013,363.0659 177.6193,363.0559 177.6373,363.0459 C177.6553,363.0379 177.6743,363.0289 177.6943,363.0199 C177.7113,363.0119 177.7283,363.0049 177.7463,362.9989",
    id: "Stroke-861",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.7104,
    y1: 361.6879,
    x2: 179.7414,
    y2: 363.2179,
    id: "Stroke-863",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.7412,363.2182 C179.7982,363.2392 179.8592,363.2532 179.9202,363.2562 C179.9822,363.2582 180.0432,363.2492 180.1012,363.2282",
    id: "Stroke-865",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.7075,
    y1: 320.7309,
    x2: 287.6775,
    y2: 319.2019,
    id: "Stroke-867",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.0678,320.7407 C292.0098,320.7627 291.9488,320.7717 291.8868,320.7697 C291.8258,320.7667 291.7648,320.7537 291.7078,320.7307",
    id: "Stroke-869",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.8418,
    y1: 320.0229,
    x2: 289.8418,
    y2: 320.1099,
    id: "Stroke-871",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.4462,
    y1: 7.9101,
    x2: 150.0312,
    y2: 14.5831,
    id: "Stroke-873",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.3691,
    y1: 7.122,
    x2: 132.4461,
    y2: 7.91,
    id: "Stroke-875",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.4941,
    y1: 6.7895,
    x2: 130.3691,
    y2: 7.1225,
    id: "Stroke-877",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.6108,
    y1: 15.122,
    x2: 128.0728,
    y2: 7.329,
    id: "Stroke-879",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9629,
    y1: 253.3891,
    x2: 18.9899,
    y2: 254.1591,
    id: "Stroke-881",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9897,254.1586 C19.0227,254.1716 19.0557,254.1846 19.0867,254.2016 C19.1187,254.2176 19.1497,254.2356 19.1777,254.2576 C19.2057,254.2776 19.2327,254.3036 19.2527,254.3316 C19.2587,254.3396 19.2627,254.3466 19.2667,254.3546 C19.2707,254.3626 19.2747,254.3706 19.2777,254.3786 C19.2837,254.3946 19.2867,254.4126 19.2867,254.4306",
    id: "Stroke-883",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.9897,
    y1: 254.7026,
    x2: 14.4677,
    y2: 256.4196,
    id: "Stroke-885",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4673,256.4194 C14.4403,256.4294 14.4133,256.4384 14.3853,256.4464 C14.3553,256.4564 14.3243,256.4644 14.2933,256.4724 C14.2643,256.4794 14.2353,256.4844 14.2063,256.4904 C14.1753,256.4964 14.1453,256.5014 14.1133,256.5064 C13.9943,256.5234 13.8713,256.5314 13.7503,256.5314 C13.6293,256.5314 13.5063,256.5234 13.3863,256.5064 C13.3553,256.5014 13.3243,256.4964 13.2933,256.4904 C13.2643,256.4844 13.2363,256.4794 13.2073,256.4724 C13.1763,256.4644 13.1453,256.4564 13.1143,256.4464 C13.0873,256.4384 13.0603,256.4294 13.0323,256.4194",
    id: "Stroke-887",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.0327,
    y1: 256.4194,
    x2: 11.0067,
    y2: 255.6494,
    id: "Stroke-889",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0063,255.6499 C10.9733,255.6369 10.9403,255.6239 10.9083,255.6069 C10.8773,255.5909 10.8463,255.5729 10.8183,255.5509 C10.7903,255.5309 10.7633,255.5049 10.7433,255.4769 C10.7373,255.4689 10.7333,255.4619 10.7293,255.4539 C10.7243,255.4459 10.7213,255.4379 10.7183,255.4299 C10.7123,255.4129 10.7093,255.3959 10.7093,255.3779",
    id: "Stroke-891",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5859,
    y1: 261.31,
    x2: 64.1689,
    y2: 283.54,
    id: "Stroke-893",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.1069,
    y1: 260.3696,
    x2: 5.5859,
    y2: 261.3096,
    id: "Stroke-895",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5288,
    y1: 253.3891,
    x2: 11.0068,
    y2: 255.1061,
    id: "Stroke-897",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.1069,
    y1: 256.6518,
    x2: 19.7099,
    y2: 250.3508,
    id: "Stroke-899",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.1689,
    y1: 279.8217,
    x2: 3.1069,
    y2: 256.6517,
    id: "Stroke-901",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.7719,
    y1: 273.5219,
    x2: 64.1689,
    y2: 279.8219,
    id: "Stroke-903",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.0605,
    y1: 253.8999,
    x2: 80.7715,
    y2: 273.5219,
    id: "Stroke-905",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.7099,
    y1: 250.351,
    x2: 29.0609,
    y2: 253.9,
    id: "Stroke-907",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.7719,
    y1: 277.2397,
    x2: 80.7719,
    y2: 273.5217,
    id: "Stroke-909",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.709,255.3774 C10.709,255.3594 10.712,255.3424 10.719,255.3254 C10.721,255.3174 10.725,255.3104 10.729,255.3024 C10.733,255.2944 10.738,255.2864 10.743,255.2784 C10.764,255.2504 10.791,255.2254 10.818,255.2044 C10.846,255.1834 10.877,255.1644 10.909,255.1484 C10.94,255.1324 10.973,255.1184 11.006,255.1064",
    id: "Stroke-911",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.124,
    y1: 308.0922,
    x2: 81.124,
    y2: 329.4172,
    id: "Stroke-913",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.124,
    y1: 329.4174,
    x2: 80.665,
    y2: 329.2434,
    id: "Stroke-915",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.9404,
    y1: 269.1391,
    x2: 20.5784,
    y2: 266.9991,
    id: "Stroke-917",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6645,
    y1: 329.7182,
    x2: 80.6645,
    y2: 277.2802,
    id: "Stroke-919",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.8227,
    y1: 278.3588,
    x2: 77.8227,
    y2: 330.7968,
    id: "Stroke-921",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.9424,
    y1: 48.7563,
    x2: 23.4654,
    y2: 48.1783,
    id: "Stroke-923",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.1323,
    y1: 51.3403,
    x2: 21.9423,
    y2: 48.7563,
    id: "Stroke-925",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.8862,
    y1: 48.7177,
    x2: 16.5412,
    y2: 51.8847,
    id: "Stroke-927",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.5512,
    y1: 41.4614,
    x2: 272.1132,
    y2: 87.2094,
    id: "Stroke-929",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.1508,
    y1: 70.8852,
    x2: 315.1508,
    y2: 70.8982,
    id: "Stroke-931",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.6953,
    y1: 71.058,
    x2: 315.1513,
    y2: 70.885,
    id: "Stroke-933",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.6953,
    y1: 71.058,
    x2: 140.3073,
    y2: 4.885,
    id: "Stroke-935",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.2451,
    y1: 12.4848,
    x2: 315.1511,
    y2: 70.8848,
    id: "Stroke-937",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.1816,
    y1: 4.8715,
    x2: 161.2446,
    y2: 12.4845,
    id: "Stroke-939",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.1289,
    y1: 51.3491,
    x2: 35.5569,
    y2: 59.1001,
    id: "Stroke-941",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.1015,
    y1: 47.9238,
    x2: 15.1285,
    y2: 51.3488,
    id: "Stroke-943",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.1357,
    y1: 59.6401,
    x2: 4.6807,
    y2: 48.4631,
    id: "Stroke-945",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.8618,
    y1: 227.4223,
    x2: 41.6368,
    y2: 257.2193,
    id: "Stroke-947",
    stroke: "#424242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.355,194.1606 L15.958,190.8286 C16.324,190.8286 16.621,191.1256 16.621,191.4916 L16.621,200.0946 C16.621,200.4606 16.324,200.7576 15.958,200.7576 L7.355,204.0896 C6.989,204.0896 6.692,203.7926 6.692,203.4266 L6.692,194.8236 C6.692,194.4576 6.989,194.1606 7.355,194.1606 Z",
    id: "Stroke-949",
    stroke: "#000000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.7763,
    y1: 196.7246,
    x2: 6.8393,
    y2: 194.4886,
    id: "Stroke-951",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.4736,
    y1: 200.5576,
    x2: 14.1146,
    y2: 198.1836,
    id: "Stroke-953",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.8144,
    y1: 199.0322,
    x2: 7.0224,
    y2: 203.9552,
    id: "Stroke-955",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.3852,
    y1: 190.9624,
    x2: 14.0782,
    y2: 195.8904,
    id: "Stroke-957",
    stroke: "#2E3030",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9033,196.6616 L13.9833,195.8566 C14.0713,195.8566 14.1433,195.9286 14.1433,196.0166 L14.1433,198.0966 C14.1433,198.1846 14.0713,198.2566 13.9833,198.2566 L11.9033,199.0616 C11.8153,199.0616 11.7433,198.9906 11.7433,198.9016 L11.7433,196.8216 C11.7433,196.7336 11.8153,196.6616 11.9033,196.6616 Z",
    id: "Stroke-959",
    stroke: "#2E3030",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBedSofa);
export default __webpack_public_path__ + "static/media/cloud_bed_sofa.43c09d1622b951a379408275f6032ba7.svg";
export { ForwardRef as ReactComponent };